(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("9YpHb", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getPreferredContentType", function () { return $742da6395d223c31$export$97379bd49d02b948; });
$parcel$export(module.exports, "OptimizedForLCP", function () { return $742da6395d223c31$export$e01e433cebf05247; });
$parcel$export(module.exports, "LazySection", function () { return $742da6395d223c31$export$2cba584408128820; });
$parcel$export(module.exports, "Show", function () { return $742da6395d223c31$export$f6a3d19be20f5819; });
$parcel$export(module.exports, "make", function () { return $742da6395d223c31$export$dd44f18ab656f3bb; });
$parcel$export(module.exports, "$$default", function () { return $742da6395d223c31$export$aa541d093b11ace2; });
$parcel$export(module.exports, "default", function () { return $742da6395d223c31$export$aa541d093b11ace2; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $i3Bxr = parcelRequire("i3Bxr");

var $IFWJb = parcelRequire("IFWJb");

var $hvzQE = parcelRequire("hvzQE");

var $239BR = parcelRequire("239BR");

var $kEThe = parcelRequire("kEThe");

var $2jMpY = parcelRequire("2jMpY");

var $7E1DP = parcelRequire("7E1DP");

var $czXEM = parcelRequire("czXEM");

var $hkOky = parcelRequire("hkOky");

var $bbixw = parcelRequire("bbixw");

var $56FYA = parcelRequire("56FYA");

var $jKda8 = parcelRequire("jKda8");

var $hBcYV = parcelRequire("hBcYV");

var $3uZKH = parcelRequire("3uZKH");

var $lGias = parcelRequire("lGias");

var $dKeuY = parcelRequire("dKeuY");

var $4QdUt = parcelRequire("4QdUt");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $v7lDW = parcelRequire("v7lDW");

var $jtD5N = parcelRequire("jtD5N");

var $9zTTJ = parcelRequire("9zTTJ");

var $8E2YL = parcelRequire("8E2YL");

var $jHdza = parcelRequire("jHdza");

var $3cqdW = parcelRequire("3cqdW");

var $84pt4 = parcelRequire("84pt4");

var $g3aLS = parcelRequire("g3aLS");

var $hM6fK = parcelRequire("hM6fK");

var $jQE31 = parcelRequire("jQE31");

var $7MOac = parcelRequire("7MOac");

var $6EwcS = parcelRequire("6EwcS");

var $5RX6O = parcelRequire("5RX6O");

var $cMFWg = parcelRequire("cMFWg");

var $ij6do = parcelRequire("ij6do");
function $742da6395d223c31$export$97379bd49d02b948(category) {
    var match = $1xf0g.ExternalConnection.getConnection(category);
    if (match === undefined) return /* Products */ 0;
    if (typeof match !== "number") return /* Products */ 0;
    switch(match){
        case /* History */ 0:
            return /* History */ 3;
        case /* Favorites */ 1:
            return /* Favorites */ 2;
        case /* StoreCart */ 2:
            return /* StoreCart */ 4;
    }
}
function $742da6395d223c31$var$ListPageContent$OptimizedForLCP(Props) {
    var category = Props.category;
    var parentCategory = Props.parentCategory;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var index = Props.index;
    var preferredContentType = Props.preferredContentType;
    var priority = Props.priority;
    var anchorHookResult = Props.anchorHookResult;
    var layout = $g85JO.useMemo(function() {
        var match = category.userSelectedLayout;
        if (typeof match === "number") return;
        switch(match.TAG | 0){
            case /* SubCategoriesGrid */ 2:
            case /* ProductGrid */ 3:
                return {
                    TAG: /* GridLayout */ 1,
                    _0: match._0
                };
            default:
                return {
                    TAG: /* SliderLayout */ 0,
                    _0: match._0
                };
        }
    }, [
        category.userSelectedLayout
    ]);
    var match = category.userSelectedLayout;
    var preferredContentType$1;
    if (typeof match === "number") preferredContentType$1 = /* Category */ 1;
    else switch(match.TAG | 0){
        case /* ProductGrid */ 3:
        case /* ProductSlider */ 4:
            preferredContentType$1 = preferredContentType;
            break;
        default:
            preferredContentType$1 = /* Category */ 1;
    }
    var match$1 = category.userSelectedLayout;
    var shouldShowHeader;
    if (typeof match$1 === "number") shouldShowHeader = undefined;
    else switch(match$1.TAG | 0){
        case /* ProductGrid */ 3:
        case /* ProductSlider */ 4:
            shouldShowHeader = true;
            break;
        default:
            shouldShowHeader = undefined;
    }
    if (layout === undefined) return null;
    var tmp = {
        index: index,
        preferredContentType: preferredContentType$1,
        category: category,
        parentCategory: parentCategory,
        layout: layout,
        scrollableContainerRef: scrollableContainerRef,
        priority: priority
    };
    if (shouldShowHeader !== undefined) tmp.shouldShowHeader = $loT9g.valFromOption(shouldShowHeader);
    if (anchorHookResult !== undefined) tmp.anchorHookResult = $loT9g.valFromOption(anchorHookResult);
    return /*#__PURE__*/ $g85JO.createElement($3uZKH.make, tmp);
}
$742da6395d223c31$var$ListPageContent$OptimizedForLCP.displayName = "ListPageContent.OptimizedForLCP";
var $742da6395d223c31$export$e01e433cebf05247 = {
    make: $742da6395d223c31$var$ListPageContent$OptimizedForLCP
};
function $742da6395d223c31$var$ListPageContent$LazySection(Props) {
    var category = Props.category;
    var parentCategory = Props.parentCategory;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var index = Props.index;
    var anchorHookResult = Props.anchorHookResult;
    var match = $hBcYV.useRouter(undefined);
    var previewMode = match.previewMode;
    var match$1 = $IFWJb.use(undefined);
    var isMainImageRendered = match$1.isMainImageRendered;
    return /*#__PURE__*/ $g85JO.createElement($239BR.make, {
        render: function render(priority) {
            var tmp;
            if (isMainImageRendered && priority <= 1 || priority === 0 || $7bjme.equal(previewMode, /* PreviewHead */ 0)) tmp = /*#__PURE__*/ $g85JO.createElement($742da6395d223c31$var$ListPageContent$OptimizedForLCP, {
                category: category,
                parentCategory: parentCategory,
                scrollableContainerRef: scrollableContainerRef,
                index: index,
                preferredContentType: $742da6395d223c31$export$97379bd49d02b948(category),
                priority: priority,
                anchorHookResult: anchorHookResult
            });
            else {
                var tmp$1 = {
                    category: category
                };
                if (anchorHookResult !== undefined) tmp$1.anchorHookResult = $loT9g.valFromOption(anchorHookResult);
                tmp = /*#__PURE__*/ $g85JO.createElement($3uZKH.SectionPlaceholder.make, tmp$1);
            }
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, tmp);
        },
        key: category.id
    });
}
$742da6395d223c31$var$ListPageContent$LazySection.displayName = "ListPageContent.LazySection";
var $742da6395d223c31$export$2cba584408128820 = {
    make: $742da6395d223c31$var$ListPageContent$LazySection
};
function $742da6395d223c31$var$ListPageContent$Show(Props) {
    var listPageContentType = Props.listPageContentType;
    var parentCategory = Props.parentCategory;
    var topLevelCategories = Props.topLevelCategories;
    var isForcingPLP = Props.isForcingPLP;
    var isMobile = Props.isMobile;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var anchorHookResult = Props.anchorHookResult;
    var onBackClick = Props.onBackClick;
    var onAddToCart = Props.onAddToCart;
    var onCategoryClick = Props.onCategoryClick;
    var onOpenLink = Props.onOpenLink;
    var displayVariantBy = $jtD5N.useDisplayVariantBy(undefined);
    var match = $8E2YL.use(undefined);
    var settings = match.config.settings;
    var match$1 = $hBcYV.useRouter(undefined);
    var match$2 = $IFWJb.use(undefined);
    var onMainImageRendered = match$2.onMainImageRendered;
    var match$3 = $9pMGg.use(undefined);
    var isMiniPDPVisible = match$3.isMiniPDPVisible;
    var onProductClick = match$3.onProductClick;
    var trackEvent = match$3.trackEvent;
    var match$4 = $g3aLS.use(undefined);
    var isZoomEnabled = match$4.isZoomEnabled;
    var gridColumns = match$4.gridColumns;
    var match$5 = $6EwcS.use(undefined);
    var history = match$5.history;
    var onRelatedProductClicked = $g85JO.useCallback(function(product) {
        return function(variant) {
            $iv6Yc.app(trackEvent, [
                "Clicked Related Product Card",
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            return $iv6Yc._2(onProductClick, product, variant);
        };
    }, [
        trackEvent,
        onProductClick
    ]);
    var renderHistorySlider = function renderHistorySlider(param) {
        var canRenderHistorySlider = settings.historyEnabled && settings.plpHistorySliderEnabled && history.value.length !== 0;
        if (canRenderHistorySlider) return /*#__PURE__*/ $g85JO.createElement("div", {
            style: {
                paddingTop: $ezf3v.intToPx(isMobile ? 20 : 24),
                paddingBottom: $ezf3v.intToPx(isMobile ? 20 : 24)
            }
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "text-primary font-heading",
                "mb-6",
                isMobile ? "text-lg" : "text-xl"
            ])),
            style: {
                paddingRight: $ezf3v.intToPx(isMobile ? 12 : 24),
                paddingLeft: $ezf3v.intToPx(isMobile ? 12 : 24)
            }
        }, "Recently Viewed"), /*#__PURE__*/ $g85JO.createElement($7MOac.make, {
            layout: {
                TAG: /* SliderLayout */ 0,
                _0: {
                    slidesPerView: isMobile ? 2.1 : 4.1,
                    gap: isMobile ? /* Pixels */ {
                        _0: 6
                    } : /* Pixels */ {
                        _0: 8
                    },
                    maxWidth: $i3Bxr.emptySliderPayload.maxWidth,
                    padding: $i3Bxr.emptySliderPayload.padding,
                    rows: $i3Bxr.emptySliderPayload.rows,
                    effect: $i3Bxr.emptySliderPayload.effect,
                    nav: $i3Bxr.emptySliderPayload.nav,
                    transition: $i3Bxr.emptySliderPayload.transition,
                    transitionSpeed: $i3Bxr.emptySliderPayload.transitionSpeed,
                    autoplay: $i3Bxr.emptySliderPayload.autoplay,
                    autoplayDelay: $i3Bxr.emptySliderPayload.autoplayDelay,
                    loop: $i3Bxr.emptySliderPayload.loop
                }
            },
            zoomable: false,
            requestType: "history"
        }));
        else return null;
    };
    var getContentOptimizedForLCP = function getContentOptimizedForLCP(categories) {
        return $i7mYY.mapWithIndex($i7mYY.keep(categories, function(category) {
            if ($1xf0g.hasAnyItems(category)) return category.visibleInSectionList;
            else return false;
        }), function(index, category) {
            return /*#__PURE__*/ $g85JO.createElement($742da6395d223c31$var$ListPageContent$LazySection, {
                category: category,
                parentCategory: parentCategory,
                scrollableContainerRef: scrollableContainerRef,
                index: index,
                anchorHookResult: anchorHookResult,
                key: category.id
            });
        });
    };
    if (typeof listPageContentType === "number") switch(listPageContentType){
        case /* HistoryProducts */ 0:
            return /*#__PURE__*/ $g85JO.createElement($7MOac.make, {
                layout: {
                    TAG: /* GridLayout */ 1,
                    _0: {
                        columns: isZoomEnabled ? gridColumns : isMobile ? /* TwoColumnGrid */ 1 : /* FourColumnGrid */ 3,
                        gap: $i3Bxr.emptyGridPayload.gap,
                        maxRows: $i3Bxr.emptyGridPayload.maxRows,
                        maxWidth: $i3Bxr.emptyGridPayload.maxWidth,
                        padding: $i3Bxr.emptyGridPayload.padding,
                        pattern: $i3Bxr.emptyGridPayload.pattern
                    }
                },
                requestType: "history"
            });
        case /* FavoriteProducts */ 1:
            return /*#__PURE__*/ $g85JO.createElement($7MOac.make, {
                layout: {
                    TAG: /* GridLayout */ 1,
                    _0: {
                        columns: isZoomEnabled ? gridColumns : isMobile ? /* TwoColumnGrid */ 1 : /* FourColumnGrid */ 3,
                        gap: $i3Bxr.emptyGridPayload.gap,
                        maxRows: $i3Bxr.emptyGridPayload.maxRows,
                        maxWidth: $i3Bxr.emptyGridPayload.maxWidth,
                        padding: $i3Bxr.emptyGridPayload.padding,
                        pattern: $i3Bxr.emptyGridPayload.pattern
                    }
                },
                requestType: "favorites"
            });
        case /* StoreCartProducts */ 2:
            return /*#__PURE__*/ $g85JO.createElement($7MOac.make, {
                layout: {
                    TAG: /* GridLayout */ 1,
                    _0: {
                        columns: isZoomEnabled ? gridColumns : isMobile ? /* TwoColumnGrid */ 1 : /* FourColumnGrid */ 3,
                        gap: $i3Bxr.emptyGridPayload.gap,
                        maxRows: $i3Bxr.emptyGridPayload.maxRows,
                        maxWidth: $i3Bxr.emptyGridPayload.maxWidth,
                        padding: $i3Bxr.emptyGridPayload.padding,
                        pattern: $i3Bxr.emptyGridPayload.pattern
                    }
                },
                requestType: "cart"
            });
        case /* UnknownListing */ 3:
            return /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
                error: $4QdUt.makeError(false, 'Could not find a suitable view for this category "' + $2whNH.mapWithDefault(match$1.listPageType, "", function(id) {
                    if (typeof id === "number") switch(id){
                        case /* Favorites */ 0:
                            return "Favorites";
                        case /* History */ 1:
                            return "History";
                        case /* StoreCart */ 2:
                            return "StoreCart";
                    }
                    else switch(id.TAG | 0){
                        case /* Category */ 0:
                            return "Category(" + id._0 + ")";
                        case /* Product */ 1:
                            return "Product(" + id._0 + ")";
                        case /* StoreCategory */ 2:
                            return "StoreCategory(" + id._0.categoryId + ")";
                    }
                }) + '".'),
                redirect: onBackClick
            });
        case /* EmptyListing */ 4:
            return null;
    }
    else switch(listPageContentType.TAG | 0){
        case /* IndexSlider */ 0:
            return getContentOptimizedForLCP(topLevelCategories);
        case /* IndexGrid */ 1:
            var gridPayload = listPageContentType._0;
            var content = $i7mYY.map($i7mYY.keep(topLevelCategories, function(category) {
                if ($1xf0g.isIndexNode(category)) return false;
                else return category.visibleInParent;
            }), function(category) {
                return /*#__PURE__*/ $g85JO.createElement($7E1DP.make, {
                    category: category,
                    shape: $2whNH.mapWithDefault(settings.indexNode, settings.categoryCardShape, function(node) {
                        return $1xf0g.CategoryCard.getCardShape(undefined, undefined, node.card);
                    }),
                    onClick: onCategoryClick,
                    key: category.id
                });
            });
            return /*#__PURE__*/ $g85JO.createElement($czXEM.make, {
                columns: gridPayload.columns,
                children: content,
                gap: gridPayload.gap
            });
        case /* IndexWithFilters */ 2:
            var category = listPageContentType._0;
            var gridPayload$1 = category.forcedPLPLayout;
            var gridLayout;
            gridLayout = typeof gridPayload$1 === "number" || gridPayload$1.TAG !== /* ProductGrid */ 3 ? {
                columns: /* SevenColumnGrid */ 6,
                gap: /* Half */ 1,
                maxRows: undefined,
                maxWidth: undefined,
                padding: undefined,
                pattern: undefined
            } : gridPayload$1._0;
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($3uZKH.make, {
                index: 0,
                preferredContentType: /* Products */ 0,
                shouldShowHeader: !isForcingPLP && $1xf0g.hasSubCategories(category),
                shouldShowBackToTopButton: !isMobile,
                category: category,
                parentCategory: parentCategory,
                layout: {
                    TAG: /* GridLayout */ 1,
                    _0: gridLayout
                },
                scrollableContainerRef: scrollableContainerRef,
                enableInlineMedia: true,
                isThemeEnabled: false
            }), renderHistorySlider(undefined));
        case /* CLPGrid */ 3:
            return /*#__PURE__*/ $g85JO.createElement($3uZKH.make, {
                index: 0,
                preferredContentType: /* Category */ 1,
                shouldShowHeader: false,
                category: listPageContentType._0,
                parentCategory: parentCategory,
                layout: {
                    TAG: /* GridLayout */ 1,
                    _0: listPageContentType._1
                },
                scrollableContainerRef: scrollableContainerRef,
                isThemeEnabled: false
            });
        case /* CLPSlider */ 4:
            return getContentOptimizedForLCP($1xf0g.getChildren(listPageContentType._0));
        case /* CLPWithHeader */ 5:
            var category$1 = listPageContentType._0;
            var headerContent;
            if (isMobile || !settings.smartbarEnabled) {
                var newrecord = $7bjme.obj_dup(category$1);
                headerContent = /*#__PURE__*/ $g85JO.createElement($3uZKH.make, {
                    index: 0,
                    preferredContentType: /* Category */ 1,
                    applyVisibleInHeader: true,
                    category: (newrecord.title = $2jMpY.concatWithoutRepeat("All", category$1.title), newrecord),
                    parentCategory: parentCategory,
                    layout: {
                        TAG: /* SliderLayout */ 0,
                        _0: listPageContentType._1
                    },
                    scrollableContainerRef: scrollableContainerRef,
                    layoutControllerHook: $jQE31.useSubMenuSliderHeightSetter,
                    onTitleClick: match$3.onSmartCardClick,
                    key: category$1.id
                });
            } else headerContent = null;
            var mainContent = getContentOptimizedForLCP($1xf0g.getChildren(category$1));
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, headerContent, mainContent);
        case /* CLPWithFilters */ 6:
            var category$2 = listPageContentType._0;
            var match$6 = category$2.forcedPLPLayout;
            var match$7;
            if (typeof match$6 === "number" || match$6.TAG !== /* ProductGrid */ 3) match$7 = [
                /* SevenColumnGrid */ 6,
                /* Half */ 1,
                undefined,
                undefined,
                undefined
            ];
            else {
                var match$8 = match$6._0;
                match$7 = [
                    match$8.columns,
                    match$8.gap,
                    match$8.maxRows,
                    match$8.maxWidth,
                    match$8.padding
                ];
            }
            var tmp = {
                index: 0,
                preferredContentType: /* Products */ 0,
                shouldShowHeader: !isForcingPLP && $1xf0g.hasSubCategories(category$2),
                shouldShowBackToTopButton: !isMobile,
                category: category$2,
                parentCategory: parentCategory,
                layout: {
                    TAG: /* GridLayout */ 1,
                    _0: {
                        columns: isZoomEnabled ? gridColumns : match$7[0],
                        gap: match$7[1],
                        maxRows: match$7[2],
                        maxWidth: match$7[3],
                        padding: match$7[4],
                        pattern: undefined
                    }
                },
                scrollableContainerRef: scrollableContainerRef,
                enableInlineMedia: true,
                isThemeEnabled: false
            };
            var tmp$1 = isForcingPLP ? settings.productCardShape : undefined;
            if (tmp$1 !== undefined) tmp.forcedShape = $loT9g.valFromOption(tmp$1);
            var tmp$2 = isForcingPLP ? settings.productCardSize : undefined;
            if (tmp$2 !== undefined) tmp.forcedSize = $loT9g.valFromOption(tmp$2);
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($3uZKH.make, tmp), renderHistorySlider(undefined));
        case /* PLPGrid */ 7:
            var match$9 = listPageContentType._1;
            var category$3 = listPageContentType._0;
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($3uZKH.make, {
                index: 0,
                preferredContentType: $742da6395d223c31$export$97379bd49d02b948(category$3),
                shouldShowHeader: !isForcingPLP && $1xf0g.hasSubCategories(category$3),
                shouldShowBackToTopButton: !isMobile,
                category: category$3,
                parentCategory: parentCategory,
                layout: {
                    TAG: /* GridLayout */ 1,
                    _0: {
                        columns: isZoomEnabled ? gridColumns : match$9.columns,
                        gap: match$9.gap,
                        maxRows: match$9.maxRows,
                        maxWidth: match$9.maxWidth,
                        padding: match$9.padding,
                        pattern: undefined
                    }
                },
                scrollableContainerRef: scrollableContainerRef,
                enableInlineMedia: true,
                isThemeEnabled: false
            }), renderHistorySlider(undefined));
        case /* PLPSlider */ 8:
            var category$4 = listPageContentType._0;
            return /*#__PURE__*/ $g85JO.createElement($3uZKH.make, {
                index: 0,
                preferredContentType: $742da6395d223c31$export$97379bd49d02b948(category$4),
                shouldShowHeader: !isForcingPLP && $1xf0g.hasSubCategories(category$4),
                shouldShowBackToTopButton: !isMobile,
                category: category$4,
                parentCategory: parentCategory,
                layout: {
                    TAG: /* SliderLayout */ 0,
                    _0: listPageContentType._1
                },
                scrollableContainerRef: scrollableContainerRef,
                isThemeEnabled: false
            });
        case /* RelatedProducts */ 9:
            var columns = isMobile ? /* TwoColumnGrid */ 1 : $1xf0g.determineProductGridLayoutWithCardSize(undefined, undefined, settings.productCardSize);
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($84pt4.make, {
                productId: listPageContentType.productId,
                categoryId: "",
                hideOutOfStock: settings.hideOutOfStock,
                viewport: scrollableContainerRef,
                render: function render(products) {
                    var cards = $i7mYY.mapWithIndex(products, function(dataCount, product) {
                        var tmp = {
                            shape: settings.productCardShape,
                            product: product,
                            onClick: onRelatedProductClicked,
                            onAddToCart: onAddToCart,
                            onImageRendered: onMainImageRendered,
                            onOpenLink: onOpenLink,
                            dataCount: dataCount,
                            key: product.id
                        };
                        if (isMiniPDPVisible !== undefined) tmp.isMiniPDPVisible = $loT9g.valFromOption(isMiniPDPVisible);
                        return /*#__PURE__*/ $g85JO.createElement($kEThe.make, tmp);
                    });
                    return /*#__PURE__*/ $g85JO.createElement($czXEM.make, {
                        columns: columns,
                        children: cards
                    });
                },
                displayVariantBySelector: displayVariantBy
            }), renderHistorySlider(undefined));
        case /* StoreCategoryProducts */ 10:
            var tmp$3 = {
                layout: {
                    TAG: /* GridLayout */ 1,
                    _0: {
                        columns: isZoomEnabled ? gridColumns : isMobile ? /* TwoColumnGrid */ 1 : /* FourColumnGrid */ 3,
                        gap: $i3Bxr.emptyGridPayload.gap,
                        maxRows: $i3Bxr.emptyGridPayload.maxRows,
                        maxWidth: $i3Bxr.emptyGridPayload.maxWidth,
                        padding: $i3Bxr.emptyGridPayload.padding,
                        pattern: $i3Bxr.emptyGridPayload.pattern
                    }
                },
                categoryId: listPageContentType.categoryId,
                isZoomEnabled: isZoomEnabled,
                scrollableContainerRef: scrollableContainerRef
            };
            if (listPageContentType.sourceNodeId !== undefined) tmp$3.sourceNodeId = listPageContentType.sourceNodeId;
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($cMFWg.make, tmp$3), renderHistorySlider(undefined));
    }
}
$742da6395d223c31$var$ListPageContent$Show.displayName = "ListPageContent.Show";
var $742da6395d223c31$var$make = /*#__PURE__*/ $g85JO.memo($742da6395d223c31$var$ListPageContent$Show);
var $742da6395d223c31$export$f6a3d19be20f5819 = {
    make: $742da6395d223c31$var$make
};
function $742da6395d223c31$var$ListPageContent(Props) {
    var scrollableContainerRef = Props.scrollableContainerRef;
    var isSidebarOpen = Props.isSidebarOpen;
    var isMobileFiltersOpen = Props.isMobileFiltersOpen;
    var anchorHookResult = Props.anchorHookResult;
    var match = $9pMGg.use(undefined);
    var onCategoryClick = match.onCategoryClick;
    var embedType = match.embedType;
    var match$1 = $aSJcu.use(undefined);
    var isMobile = match$1.isMobile;
    var match$2 = $IFWJb.use(undefined);
    var isMainImageRendered = match$2.isMainImageRendered;
    var match$3 = $8E2YL.use(undefined);
    var match$4 = match$3.config;
    var settings = match$4.settings;
    var topLevelCategories = match$4.categories;
    var match$5 = $hBcYV.useRouter(undefined);
    var listPageType = match$5.listPageType;
    var quickViewUnderlyingRoute = match$5.quickViewUnderlyingRoute;
    var _route = match$5.route;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, topLevelCategories);
    var isForcingPLP = $5RX6O.useCategoryDisplayPriority(activeCategory) === /* ProductsFirst */ 1;
    var isQuickViewOpen;
    isQuickViewOpen = typeof _route === "number" || _route.TAG !== /* QuickView */ 3 ? false : true;
    var route = quickViewUnderlyingRoute !== undefined ? quickViewUnderlyingRoute : _route;
    var indexCategory = settings.indexNode;
    var match$6 = settings.indexNode;
    var parentCategory = activeCategory !== undefined ? activeCategory : match$6 !== undefined ? match$6 : $ij6do.empty;
    var relatedProductsId = $2whNH.flatMap(listPageType, function(id) {
        if (typeof id === "number" || id.TAG !== /* Product */ 1) return;
        else return id._0;
    });
    var listPageContentType = $jKda8.getListPageContentType(parentCategory, activeCategory, indexCategory, relatedProductsId, route, isForcingPLP, undefined);
    $g85JO.useEffect(function() {
        if (isMainImageRendered) {
            $iv6Yc._1($hkOky.preload, undefined);
            $iv6Yc._1($v7lDW.preload, undefined);
            $iv6Yc._1($hM6fK.preload, undefined);
        }
    }, [
        isMainImageRendered
    ]);
    var match$7 = $hvzQE.isEnabled(activeCategory, settings, listPageType, isForcingPLP);
    var shouldShowSidebar = match$7[0] || match$7[1] ? true : false;
    var connection = $2whNH.flatMap(activeCategory, $1xf0g.ExternalConnection.getStoreCategoryConnection);
    var content = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: !isMobile || !isQuickViewOpen,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "smartnav-main flex flex-col w-full",
                $2whNH.mapWithDefault(activeCategory, "space-y-row-custom pt-row-custom-half", function(category) {
                    if ($2whNH.isSome(category.socialNetworkSource)) return "";
                    else return "space-y-row-custom pt-row-custom-half";
                })
            ]))
        }, /*#__PURE__*/ $g85JO.createElement($742da6395d223c31$var$make, {
            listPageContentType: listPageContentType,
            activeCategory: activeCategory,
            parentCategory: parentCategory,
            topLevelCategories: topLevelCategories,
            isForcingPLP: isForcingPLP,
            isSidebarOpen: isSidebarOpen,
            isMobile: isMobile,
            scrollableContainerRef: scrollableContainerRef,
            anchorHookResult: anchorHookResult,
            onBackClick: match.onBackClick,
            onAddToCart: match.onAddToCart,
            onCategoryClick: onCategoryClick,
            onOpenLink: match.onOpenLink
        }))
    });
    var tmp;
    if (typeof route === "number") tmp = false;
    else switch(route.TAG | 0){
        case /* Home */ 0:
        case /* ListPage */ 1:
            tmp = true;
            break;
        default:
            tmp = false;
    }
    var tmp$1 = {
        listPageContentType: listPageContentType,
        scrollableContainerRef: scrollableContainerRef
    };
    if (activeCategory !== undefined) tmp$1.category = $loT9g.valFromOption(activeCategory);
    var tmp$2 = {
        listPageContentType: listPageContentType,
        isSidebarOpen: isSidebarOpen,
        topLevelCategories: topLevelCategories
    };
    if (anchorHookResult !== undefined) tmp$2.anchorHookResult = $loT9g.valFromOption(anchorHookResult);
    if (activeCategory !== undefined) tmp$2.category = $loT9g.valFromOption(activeCategory);
    var tmp$3;
    var exit = 0;
    if (typeof listPageContentType === "number") exit = 1;
    else switch(listPageContentType.TAG | 0){
        case /* IndexSlider */ 0:
        case /* IndexGrid */ 1:
            if (embedType !== 1) exit = 1;
            else tmp$3 = null;
            break;
        default:
            exit = 1;
    }
    if (exit === 1) tmp$3 = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("smartnav-endspace h-26 mt-6 w-full")
    });
    return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: tmp,
        children: null
    }, /*#__PURE__*/ $g85JO.createElement($56FYA.make, {
        topLevelCategories: topLevelCategories,
        activeCategory: activeCategory
    }), /*#__PURE__*/ $g85JO.createElement($lGias.make, tmp$1), /*#__PURE__*/ $g85JO.createElement($dKeuY.make, tmp$2), /*#__PURE__*/ $g85JO.createElement($9zTTJ.make, {
        scrollableContainerRef: scrollableContainerRef
    }), /*#__PURE__*/ $g85JO.createElement($jHdza.make, {
        activeCategory: activeCategory,
        connection: connection,
        isOpen: isMobileFiltersOpen
    }), content, /*#__PURE__*/ $g85JO.createElement($3cqdW.make, {
        category: activeCategory,
        appliedFilters: match$5.productFilters,
        appliedSort: match$5.productSort,
        shouldShowSidebar: shouldShowSidebar,
        isSidebarOpen: isSidebarOpen,
        topLevelCategories: topLevelCategories,
        onCategoryClick: onCategoryClick
    }), tmp$3);
}
$742da6395d223c31$var$ListPageContent.displayName = "ListPageContent";
var $742da6395d223c31$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($742da6395d223c31$var$ListPageContent);
var $742da6395d223c31$export$aa541d093b11ace2 = $742da6395d223c31$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("hkOky", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $c9eb58822e67ded0$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $c9eb58822e67ded0$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $c9eb58822e67ded0$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("goodF"));
});
function $c9eb58822e67ded0$var$Sidebar_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($c9eb58822e67ded0$var$component, Props);
}
$c9eb58822e67ded0$var$Sidebar_Lazy.displayName = "Sidebar_Lazy";
var $c9eb58822e67ded0$export$513ccb98c53b8039 = $c9eb58822e67ded0$var$component.preload;
var $c9eb58822e67ded0$export$dd44f18ab656f3bb = $c9eb58822e67ded0$var$Sidebar_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("goodF", function(module, exports) {


module.exports = (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("i8GHl")).then(function() {
    return parcelRequire("aT6aF");
});

});


parcelRegister("56FYA", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $3b7e12dee2ecce8d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $ezf3v = parcelRequire("ezf3v");

var $heivG = parcelRequire("heivG");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $jQE31 = parcelRequire("jQE31");

var $gUsPc = parcelRequire("gUsPc");
function $3b7e12dee2ecce8d$var$ListPagePills(Props) {
    var topLevelCategories = Props.topLevelCategories;
    var activeCategory = Props.activeCategory;
    $8E2YL.use(undefined);
    var match = $9pMGg.use(undefined);
    var match$1 = $jQE31.Context.use(undefined);
    var match$2 = match$1.state;
    var offsetForStickyElements = $gUsPc.useEffective(undefined);
    var offsetForStickyElements$1 = match.embedType === /* Inline */ 1 ? offsetForStickyElements : 0;
    var offset = match$2.showPrimaryNavbar ? match$2.primaryNavbarHeight + offsetForStickyElements$1 | 0 : offsetForStickyElements$1;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "smartnav-pills",
            "sticky bg-main",
            "transition-top duration-300 z-20"
        ])),
        style: {
            top: $ezf3v.intToPx(offset - 1 | 0)
        }
    }, /*#__PURE__*/ $g85JO.createElement($heivG.SecondaryNavbar.make, {
        topLevelCategories: topLevelCategories,
        activeCategory: activeCategory,
        keepDynamic: false
    }));
}
$3b7e12dee2ecce8d$var$ListPagePills.displayName = "ListPagePills";
var $3b7e12dee2ecce8d$export$dd44f18ab656f3bb = $3b7e12dee2ecce8d$var$ListPagePills;
 /* react Not a pure module */ 
});

parcelRegister("jKda8", function(module, exports) {

$parcel$export(module.exports, "getListPageContentType", function () { return $e5fc86019e180ea6$export$d0dc5928ea9d926; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $1xf0g = parcelRequire("1xf0g");

var $i3Bxr = parcelRequire("i3Bxr");
function $e5fc86019e180ea6$export$d0dc5928ea9d926(parentCategory, activeCategory, indexCategory, relatedProductsId, route, isForcingPLP, param) {
    var listPageLayout;
    var exit = 0;
    if (typeof route === "number") exit = 1;
    else switch(route.TAG | 0){
        case /* Home */ 0:
            listPageLayout = parentCategory.listPageActiveLayout;
            break;
        case /* ListPage */ 1:
            listPageLayout = $2whNH.mapWithDefault(activeCategory, parentCategory.listPageActiveLayout, function(category) {
                return category.listPageActiveLayout;
            });
            break;
        default:
            exit = 1;
    }
    if (exit === 1) listPageLayout = {
        TAG: /* SubCategoriesGrid */ 2,
        _0: {
            columns: /* TwoColumnGrid */ 1,
            gap: $i3Bxr.emptyGridPayload.gap,
            maxRows: $i3Bxr.emptyGridPayload.maxRows,
            maxWidth: $i3Bxr.emptyGridPayload.maxWidth,
            padding: $i3Bxr.emptyGridPayload.padding,
            pattern: $i3Bxr.emptyGridPayload.pattern
        }
    };
    var exit$1 = 0;
    var exit$2 = 0;
    if (typeof route === "number") return /* EmptyListing */ 4;
    switch(route.TAG | 0){
        case /* Home */ 0:
            var match = route._0.homeType;
            if (typeof match === "number") switch(match){
                case /* Index */ 0:
                    exit$2 = 3;
                    break;
                case /* Favorites */ 1:
                    return /* FavoriteProducts */ 1;
                case /* History */ 2:
                    return /* HistoryProducts */ 0;
                case /* StoreCart */ 3:
                    return /* StoreCartProducts */ 2;
            }
            else {
                var match$1 = match._0;
                return {
                    TAG: /* StoreCategoryProducts */ 10,
                    categoryId: match$1.categoryId,
                    sourceNodeId: match$1.sourceNodeId
                };
            }
            break;
        case /* ListPage */ 1:
            var match$2 = route._0.listPageType;
            if (typeof match$2 === "number") switch(match$2){
                case /* Favorites */ 0:
                    return /* FavoriteProducts */ 1;
                case /* History */ 1:
                    return /* HistoryProducts */ 0;
                case /* StoreCart */ 2:
                    return /* StoreCartProducts */ 2;
            }
            else switch(match$2.TAG | 0){
                case /* Category */ 0:
                case /* Product */ 1:
                    exit$2 = 3;
                    break;
                case /* StoreCategory */ 2:
                    var match$3 = match$2._0;
                    return {
                        TAG: /* StoreCategoryProducts */ 10,
                        categoryId: match$3.categoryId,
                        sourceNodeId: match$3.sourceNodeId
                    };
            }
            break;
        case /* PDP */ 2:
        case /* QuickView */ 3:
            exit$2 = 3;
            break;
    }
    if (exit$2 === 3) {
        if (activeCategory !== undefined) {
            var exit$3 = 0;
            if (typeof route === "number" || route.TAG !== /* ListPage */ 1) exit$3 = 4;
            else {
                if (isForcingPLP || $2whNH.isSome(route._0.filters)) return {
                    TAG: /* CLPWithFilters */ 6,
                    _0: activeCategory
                };
                if (typeof listPageLayout === "number") return /* UnknownListing */ 3;
                switch(listPageLayout.TAG | 0){
                    case /* SubCategoriesSlider */ 0:
                        return {
                            TAG: /* CLPSlider */ 4,
                            _0: activeCategory
                        };
                    case /* SubCategoriesSliderWithHeader */ 1:
                        return {
                            TAG: /* CLPWithHeader */ 5,
                            _0: $1xf0g.setTabbedSubCategories(activeCategory, undefined),
                            _1: listPageLayout._0
                        };
                    case /* SubCategoriesGrid */ 2:
                        return {
                            TAG: /* CLPGrid */ 3,
                            _0: activeCategory,
                            _1: listPageLayout._0
                        };
                    case /* ProductGrid */ 3:
                    case /* ProductSlider */ 4:
                        exit$3 = 4;
                        break;
                }
            }
            if (exit$3 === 4) {
                if (typeof listPageLayout === "number") return /* UnknownListing */ 3;
                switch(listPageLayout.TAG | 0){
                    case /* ProductGrid */ 3:
                        return {
                            TAG: /* PLPGrid */ 7,
                            _0: activeCategory,
                            _1: listPageLayout._0
                        };
                    case /* ProductSlider */ 4:
                        return {
                            TAG: /* PLPSlider */ 8,
                            _0: activeCategory,
                            _1: listPageLayout._0
                        };
                    default:
                }
            }
        } else if (indexCategory !== undefined && !(typeof route === "number" || route.TAG !== /* Home */ 0)) {
            if (isForcingPLP || $2whNH.isSome(route._0.filters)) return {
                TAG: /* IndexWithFilters */ 2,
                _0: indexCategory
            };
            exit$1 = 2;
        } else exit$1 = 2;
    }
    if (exit$1 === 2 && relatedProductsId !== undefined) return {
        TAG: /* RelatedProducts */ 9,
        productId: relatedProductsId
    };
    if (typeof route === "number") return /* UnknownListing */ 3;
    if (route.TAG !== /* Home */ 0) return /* UnknownListing */ 3;
    if (typeof listPageLayout === "number") return /* UnknownListing */ 3;
    switch(listPageLayout.TAG | 0){
        case /* SubCategoriesSlider */ 0:
        case /* SubCategoriesSliderWithHeader */ 1:
            return {
                TAG: /* IndexSlider */ 0,
                _0: listPageLayout._0
            };
        case /* SubCategoriesGrid */ 2:
            return {
                TAG: /* IndexGrid */ 1,
                _0: listPageLayout._0
            };
        default:
            return /* UnknownListing */ 3;
    }
}
 /* Category-Showside Not a pure module */ 
});

parcelRegister("lGias", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $fc8b9cec73379f4b$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $ENKTS = parcelRequire("ENKTS");

var $9HioV = parcelRequire("9HioV");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $hBcYV = parcelRequire("hBcYV");

var $3uZKH = parcelRequire("3uZKH");

var $gevhx = parcelRequire("gevhx");

var $k0ukS = parcelRequire("k0ukS");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $jQE31 = parcelRequire("jQE31");

var $drnej = parcelRequire("drnej");

var $ij6do = parcelRequire("ij6do");
function $fc8b9cec73379f4b$var$ListPageHeading$Render(Props) {
    var titleDescriptionEnabled = Props.titleDescriptionEnabled;
    var category = Props.category;
    var position = Props.position;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $8E2YL.use(undefined);
    var topLevelCategories = match$1.config.categories;
    var renderHeading = function renderHeading(param) {
        return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "clp-sectionheader-title",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                "aria-level": 1,
                className: $ezf3v.prefix($1TRFX.make([
                    "font-heading",
                    "font-semibold",
                    "text-primary",
                    "relative",
                    isMobile ? "text-8xl" : "text-10xl",
                    position ? "text-center" : "text-left"
                ])),
                role: "heading"
            }, /*#__PURE__*/ $g85JO.createElement($k0ukS.make, {
                className: "list-page__heading",
                children: category.title
            }))
        });
    };
    var renderDescription = function renderDescription(param) {
        var description = category.description;
        if (description !== undefined && category.showDescription) return /*#__PURE__*/ $g85JO.createElement($gevhx.make, {
            maxLines: isMobile ? 4 : 3,
            className: $ezf3v.prefix($1TRFX.make([
                isMobile ? "text-xl" : "text-2xl leading-normal",
                "max-w-2xl",
                "text-secondary",
                position ? "text-center" : "text-left"
            ])),
            readMoreAriaLabel: "Expand the collection description to read more",
            readLessAriaLabel: "Collapse the collection description to read less",
            buttonDataTestId: "plp-description-expand-button",
            contentDataTestId: "plp-description",
            children: /*#__PURE__*/ $g85JO.createElement($k0ukS.make, {
                className: "list-page__subheading",
                children: description
            })
        });
        else return null;
    };
    var renderBreadcrumbs = function renderBreadcrumbs(param) {
        var match = category.categoryType;
        var needBreadcrumbs;
        if (typeof match === "number") needBreadcrumbs = false;
        else switch(match.TAG | 0){
            case /* CustomComponentSection */ 5:
            case /* EmbedCodeSection */ 6:
                needBreadcrumbs = false;
                break;
            default:
                needBreadcrumbs = true;
        }
        return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: needBreadcrumbs,
            children: /*#__PURE__*/ $g85JO.createElement($9HioV.make, {
                categories: topLevelCategories,
                className: $ezf3v.prefix($1TRFX.make([
                    titleDescriptionEnabled ? "mt-6 mb-2" : "",
                    isMobile ? "px-4" : "px-8"
                ])),
                keepLast: !titleDescriptionEnabled,
                keepSingle: titleDescriptionEnabled
            })
        });
    };
    var renderTitleDescription = function renderTitleDescription(param) {
        if (titleDescriptionEnabled) return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                isMobile ? "px-4" : "px-8",
                "space-y-2"
            ]))
        }, renderHeading(undefined), renderDescription(undefined));
        else return null;
    };
    var renderRelatedMedia = function renderRelatedMedia(param) {
        return /*#__PURE__*/ $g85JO.createElement($ENKTS.Slider.make, {
            className: $ezf3v.prefix("mt-4"),
            category: category,
            scrollableContainerRef: scrollableContainerRef,
            key: category.id
        });
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex flex-col",
            titleDescriptionEnabled ? "py-4" : "py-2",
            "hide-on-empty",
            position ? "items-center" : "items-start"
        ]))
    }, renderBreadcrumbs(undefined), renderTitleDescription(undefined), /*#__PURE__*/ $g85JO.createElement($drnej.make, {
        id: "top_of_related_media",
        adjustTo: /* AdjustToPrimaryNavbar */ 0
    }), renderRelatedMedia(undefined), /*#__PURE__*/ $g85JO.createElement($drnej.make, {
        id: "top_of_plp",
        adjustTo: /* AdjustToPrimaryNavbar */ 0
    }));
}
$fc8b9cec73379f4b$var$ListPageHeading$Render.displayName = "ListPageHeading.Render";
var $fc8b9cec73379f4b$export$160ae30d75f98247 = {
    make: $fc8b9cec73379f4b$var$ListPageHeading$Render
};
function $fc8b9cec73379f4b$var$ListPageHeading(Props) {
    var category = Props.category;
    var listPageContentType = Props.listPageContentType;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var onLinkClick = Props.onLinkClick;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $8E2YL.use(undefined);
    var settings = match$1.config.settings;
    var match$2 = $9pMGg.use(undefined);
    var match$3 = $hBcYV.useRouter(undefined);
    var ref = $g85JO.useRef(null);
    $jQE31.useTitleHeightSetter(ref);
    var parentCategory = $2whNH.getWithDefault($2whNH.orElse(category, settings.indexNode), $ij6do.empty);
    var content;
    var exit = 0;
    if (typeof listPageContentType === "number") content = null;
    else switch(listPageContentType.TAG | 0){
        case /* CLPWithHeader */ 5:
            if (isMobile || !settings.smartbarEnabled) content = null;
            else {
                var category$1 = listPageContentType._0;
                var tmp = {
                    index: 0,
                    preferredContentType: /* Category */ 1,
                    applyVisibleInHeader: true,
                    category: category$1,
                    parentCategory: parentCategory,
                    layout: {
                        TAG: /* SliderLayout */ 0,
                        _0: listPageContentType._1
                    },
                    scrollableContainerRef: scrollableContainerRef,
                    forcedSize: /* Xxxs */ 0,
                    enableSmartCard: true,
                    shouldCenterSlides: !isMobile,
                    layoutControllerHook: $jQE31.useSubMenuSliderHeightSetter,
                    onTitleClick: match$2.onSmartCardClick,
                    key: category$1.id
                };
                if (onLinkClick !== undefined) tmp.onLinkClick = $loT9g.valFromOption(onLinkClick);
                content = /*#__PURE__*/ $g85JO.createElement($3uZKH.make, tmp);
            }
            break;
        case /* IndexWithFilters */ 2:
        case /* CLPWithFilters */ 6:
        case /* PLPGrid */ 7:
        case /* PLPSlider */ 8:
        case /* StoreCategoryProducts */ 10:
            exit = 1;
            break;
        default:
            content = null;
    }
    if (exit === 1) content = /*#__PURE__*/ $g85JO.createElement($fc8b9cec73379f4b$var$ListPageHeading$Render, {
        titleDescriptionEnabled: settings.plpTitleDescriptionEnabled,
        category: parentCategory,
        appliedSort: match$3.productSort,
        appliedFilters: match$3.productFilters,
        position: settings.plpTitleDescriptionPosition,
        scrollableContainerRef: scrollableContainerRef
    });
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(ref),
        className: $ezf3v.prefix("smartnav-title relative z-20 bg-main")
    }, content);
}
$fc8b9cec73379f4b$var$ListPageHeading.displayName = "ListPageHeading";
var $fc8b9cec73379f4b$export$dd44f18ab656f3bb = $fc8b9cec73379f4b$var$ListPageHeading;
 /* react Not a pure module */ 
});
parcelRegister("9HioV", function(module, exports) {

$parcel$export(module.exports, "useBreadcrumbs", function () { return $70f6674a1658cd62$export$8cefe241bd876ca0; });
$parcel$export(module.exports, "Show", function () { return $70f6674a1658cd62$export$f6a3d19be20f5819; });
$parcel$export(module.exports, "make", function () { return $70f6674a1658cd62$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $gCzsf = parcelRequire("gCzsf");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $1jMSj = parcelRequire("1jMSj");
function $70f6674a1658cd62$export$8cefe241bd876ca0(keepLast, keepSingle, max, categories) {
    var match = $hBcYV.useRouter(undefined);
    var route = match.route;
    var match$1 = $aSJcu.use(undefined);
    var max$1 = $2whNH.getWithDefault(max, match$1.isMobile ? 3 : 8);
    var listPageType;
    listPageType = typeof route === "number" || route.TAG !== /* ListPage */ 1 ? undefined : route._0.listPageType;
    var activeCategoryId = listPageType !== undefined && !(typeof listPageType === "number" || listPageType.TAG !== /* Category */ 0) ? listPageType._0 : undefined;
    var path = activeCategoryId !== undefined ? $i7mYY.keep($1xf0g.getCategoryPathById(categories, activeCategoryId), function(category) {
        return category.title.trim() !== "";
    }) : [];
    var path$1 = $i7mYY.map($2whNH.mapWithDefault($2whNH.keep($i7mYY.get(categories, 0), $1xf0g.isIndexNode), path, function(index) {
        return $i7mYY.concat([
            index
        ], path);
    }), function(category) {
        return {
            label: category.title,
            id: category.id,
            disabled: $7bjme.equal(category.id, activeCategoryId),
            dataTestId: $7bjme.equal(category.id, activeCategoryId) ? "clp-sectionheader-title" : undefined
        };
    });
    var truncateStart = path$1.length > max$1 ? (path$1.length - 1 | 0) - max$1 | 0 : 0;
    var truncateEnd = path$1.length;
    var path$2 = $i7mYY.keepWithIndex(path$1, function(item, idx) {
        if (idx !== (path$1.length - 1 | 0)) return true;
        else return keepLast;
    });
    var truncating = path$2.length > max$1;
    var path$3 = path$2.slice(truncateStart, truncateEnd);
    var show = path$3.length > 1 || keepSingle;
    return {
        show: show,
        truncating: truncating,
        path: path$3
    };
}
function $70f6674a1658cd62$var$Breadcrumbs$Show(Props) {
    var classNameOpt = Props.className;
    var hook = Props.hook;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var path = hook.path;
    var match$1 = $aSJcu.use(undefined);
    var separator = /*#__PURE__*/ $g85JO.createElement($1jMSj.make, {
        className: $ezf3v.prefix("opacity-50")
    });
    var content = /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "breadcrumbs",
        children: /*#__PURE__*/ $g85JO.createElement("ul", {
            className: $1TRFX.make([
                className,
                $ezf3v.prefix("w-full text-secondary truncate flex flex-row items-center list-none"),
                match$1.isMobile ? $ezf3v.prefix("space-x-3") : $ezf3v.prefix("space-x-4")
            ])
        }, hook.truncating ? /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("li", {
            "aria-hidden": true,
            tabIndex: -1
        }, "..."), /*#__PURE__*/ $g85JO.createElement("li", {
            "aria-hidden": true,
            tabIndex: -1
        }, separator)) : null, $i7mYY.mapWithIndex(path, function(idx, item) {
            var isLast = idx === (path.length - 1 | 0);
            var tmp = {
                className: $ezf3v.prefix($1TRFX.make([
                    "whitespace-nowrap",
                    "text-lg",
                    item.disabled ? "" : "cursor-pointer",
                    "font-normal"
                ])),
                onClick: function onClick(param) {
                    if (item.disabled) return;
                    else {
                        var match = item.id;
                        var tmp = match === "index" ? {
                            TAG: /* Home */ 0,
                            _0: {
                                homeType: /* Index */ 0,
                                filters: undefined,
                                sort: undefined
                            }
                        } : {
                            TAG: /* ListPage */ 1,
                            _0: {
                                listPageType: {
                                    TAG: /* Category */ 0,
                                    _0: item.id
                                },
                                viewPLP: false,
                                filters: undefined,
                                sort: undefined
                            }
                        };
                        return $iv6Yc._3(goTo, undefined, undefined, tmp);
                    }
                }
            };
            var tmp$1 = item.disabled ? undefined : "link";
            if (tmp$1 !== undefined) tmp.role = $loT9g.valFromOption(tmp$1);
            var tmp$2 = item.disabled ? undefined : 0;
            if (tmp$2 !== undefined) tmp.tabIndex = $loT9g.valFromOption(tmp$2);
            var tmp$3 = {
                children: /*#__PURE__*/ $g85JO.createElement("div", undefined, /*#__PURE__*/ $g85JO.createElement("div", undefined, item.label))
            };
            if (item.dataTestId !== undefined) tmp$3.dataTestId = $loT9g.valFromOption(item.dataTestId);
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, {
                children: null,
                key: item.id
            }, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
                dataTestId: "breadcrumb-item",
                dataId: item.id,
                children: /*#__PURE__*/ $g85JO.createElement("li", tmp, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$3))
            }), isLast ? null : /*#__PURE__*/ $g85JO.createElement("li", {
                "aria-hidden": true,
                className: $ezf3v.prefix("text-lg"),
                tabIndex: -1
            }, separator));
        }))
    });
    return /*#__PURE__*/ $g85JO.createElement("div", {
        "aria-label": "Breadcrumbs",
        role: "navigation"
    }, content);
}
$70f6674a1658cd62$var$Breadcrumbs$Show.displayName = "Breadcrumbs.Show";
var $70f6674a1658cd62$export$f6a3d19be20f5819 = {
    make: $70f6674a1658cd62$var$Breadcrumbs$Show
};
function $70f6674a1658cd62$var$Breadcrumbs(Props) {
    var categories = Props.categories;
    var classNameOpt = Props.className;
    var keepLastOpt = Props.keepLast;
    var keepSingleOpt = Props.keepSingle;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var keepLast = keepLastOpt !== undefined ? keepLastOpt : false;
    var keepSingle = keepSingleOpt !== undefined ? keepSingleOpt : false;
    var hook = $70f6674a1658cd62$export$8cefe241bd876ca0(keepLast, keepSingle, undefined, categories);
    if (hook.show) return /*#__PURE__*/ $g85JO.createElement($70f6674a1658cd62$var$Breadcrumbs$Show, {
        className: className,
        hook: hook
    });
    else return null;
}
$70f6674a1658cd62$var$Breadcrumbs.displayName = "Breadcrumbs";
var $70f6674a1658cd62$export$dd44f18ab656f3bb = $70f6674a1658cd62$var$Breadcrumbs;
 /* react Not a pure module */ 
});
parcelRegister("1jMSj", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $0f5d7a5fda893eae$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $0f5d7a5fda893eae$var$IconChevronRight(Props) {
    var className = Props.className;
    var tmp = {
        height: "9",
        width: "6",
        fill: "none",
        viewBox: "0 0 6 9",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M0.875 8.81494C0.699219 8.81494 0.542969 8.75635 0.425781 8.63916C0.171875 8.40479 0.171875 7.99463 0.425781 7.76025L3.72656 4.43994L0.425781 1.13916C0.171875 0.904785 0.171875 0.494629 0.425781 0.260254C0.660156 0.00634766 1.07031 0.00634766 1.30469 0.260254L5.05469 4.01025C5.30859 4.24463 5.30859 4.65479 5.05469 4.88916L1.30469 8.63916C1.1875 8.75635 1.03125 8.81494 0.875 8.81494Z",
        fill: "currentColor"
    }));
}
$0f5d7a5fda893eae$var$IconChevronRight.displayName = "IconChevronRight";
var $0f5d7a5fda893eae$export$dd44f18ab656f3bb = $0f5d7a5fda893eae$var$IconChevronRight;
 /* react Not a pure module */ 
});


parcelRegister("gevhx", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $bd163812eafbb587$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $b5aRK = parcelRequire("b5aRK");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");
function $bd163812eafbb587$var$CollapsibleText(Props) {
    var maxLinesOpt = Props.maxLines;
    var className = Props.className;
    var readMoreLabelOpt = Props.readMoreLabel;
    var readMoreAriaLabelOpt = Props.readMoreAriaLabel;
    var readLessLabelOpt = Props.readLessLabel;
    var readLessAriaLabelOpt = Props.readLessAriaLabel;
    var buttonDataTestId = Props.buttonDataTestId;
    var contentDataTestId = Props.contentDataTestId;
    var children = Props.children;
    var maxLines = maxLinesOpt !== undefined ? maxLinesOpt : 3;
    var readMoreLabel = readMoreLabelOpt !== undefined ? readMoreLabelOpt : "Read More";
    var readMoreAriaLabel = readMoreAriaLabelOpt !== undefined ? readMoreAriaLabelOpt : "Expand the text to read more";
    var readLessLabel = readLessLabelOpt !== undefined ? readLessLabelOpt : "Read Less";
    var readLessAriaLabel = readLessAriaLabelOpt !== undefined ? readLessAriaLabelOpt : "Collapse the text to read less";
    var match = $g85JO.useState(function() {
        return false;
    });
    var setIsExpanded = match[1];
    var isExpanded = match[0];
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setShowButton = match$1[1];
    var textRef = $g85JO.useRef(null);
    var checkOverflow = function checkOverflow(param) {
        var element = $2whNH.flatMap($loT9g.nullable_to_opt(textRef.current), $b5aRK.asHtmlElement);
        if (element === undefined) return;
        var element$1 = $loT9g.valFromOption(element);
        var offsetHeight = element$1.offsetHeight;
        var scrollHeight = element$1.scrollHeight;
        $iv6Yc._1(setShowButton, function(param) {
            return scrollHeight > offsetHeight;
        });
    };
    $g85JO.useLayoutEffect(function() {
        checkOverflow(undefined);
        var listener = function listener(param) {
            checkOverflow(undefined);
        };
        window.addEventListener("resize", listener);
        return function(param) {
            window.removeEventListener("resize", listener);
        };
    });
    var tmp = {
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(textRef),
            className: $ezf3v.prefix($1TRFX.make([
                "inline",
                "overflow-hidden",
                isExpanded ? "" : $ezf3v.lineClampOfInt(maxLines)
            ]))
        }, children)
    };
    if (contentDataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(contentDataTestId);
    var tmp$1;
    if (match$1[0]) {
        var tmp$2 = {
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                "aria-label": isExpanded ? readLessAriaLabel : readMoreAriaLabel,
                className: $ezf3v.prefix($1TRFX.make([
                    "text-accent",
                    "font-semibold",
                    "inline",
                    isExpanded ? "ml-4" : "absolute bottom-0 right-0 bg-main pl-4",
                    "cursor-pointer"
                ])),
                tabIndex: 0,
                onClick: function onClick(param) {
                    $iv6Yc._1(setIsExpanded, function(x) {
                        return !x;
                    });
                }
            }, isExpanded ? readLessLabel : readMoreLabel)
        };
        if (buttonDataTestId !== undefined) tmp$2.dataTestId = $loT9g.valFromOption(buttonDataTestId);
        tmp$1 = /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$2);
    } else tmp$1 = null;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        "aria-expanded": isExpanded,
        className: $1TRFX.make([
            $ezf3v.prefix("relative"),
            $2whNH.getWithDefault(className, "")
        ])
    }, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp), tmp$1);
}
$bd163812eafbb587$var$CollapsibleText.displayName = "CollapsibleText";
var $bd163812eafbb587$export$dd44f18ab656f3bb = $bd163812eafbb587$var$CollapsibleText;
 /* react Not a pure module */ 
});

parcelRegister("drnej", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9c8fd0ed27b0a0bc$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");

var $38gYA = parcelRequire("38gYA");

var $5bEXW = parcelRequire("5bEXW");

var $efwy1 = parcelRequire("efwy1");

var $2XXXw = parcelRequire("2XXXw");

var $jQE31 = parcelRequire("jQE31");
function $9c8fd0ed27b0a0bc$var$ScrollRestorationBreaker(Props) {
    var id = Props.id;
    var adjustTo = Props.adjustTo;
    var paddingOpt = Props.padding;
    var padding = paddingOpt !== undefined ? paddingOpt : 24;
    var ref = $g85JO.useRef(null);
    $efwy1.use(undefined);
    var scrollableCtx = $38gYA.useScrollableContext(undefined);
    var match = $jQE31.Context.use(undefined);
    var match$1 = match.state;
    var showPrimaryNavbar = match$1.showPrimaryNavbar;
    var secondaryNavbarHeight = match$1.secondaryNavbarHeight;
    var primaryNavbarHeight = match$1.primaryNavbarHeight;
    var adjustToLayout = function adjustToLayout(absoluteTop) {
        switch(adjustTo){
            case /* AdjustToPrimaryNavbar */ 0:
                if (showPrimaryNavbar) return absoluteTop - primaryNavbarHeight | 0;
                else return absoluteTop;
            case /* AdjustToSecondaryNavbar */ 1:
                if (showPrimaryNavbar) return absoluteTop - (primaryNavbarHeight + secondaryNavbarHeight | 0) | 0;
                else return absoluteTop - secondaryNavbarHeight | 0;
            case /* DoNotAdjust */ 2:
                return absoluteTop;
        }
    };
    $g85JO.useEffect(function() {
        var breakerEl = ref.current;
        var handleScroll = function handleScroll(e) {
            var el = scrollableCtx.element;
            var scrollTop = el !== undefined ? $loT9g.valFromOption(el).scrollTop : window.scrollY;
            if (breakerEl == null) return;
            var absoluteTop = breakerEl.getBoundingClientRect().top + scrollTop;
            var adjustedAbsoluteTop = adjustToLayout(absoluteTop | 0);
            $2XXXw.setBreakingPoint(padding, id, adjustedAbsoluteTop);
        };
        var el = scrollableCtx.element;
        if (el !== undefined) {
            var el$1 = $loT9g.valFromOption(el);
            el$1.addEventListener("scroll", handleScroll);
            return function(param) {
                el$1.removeEventListener("scroll", handleScroll);
                $2XXXw.removeBreakingPoint(id);
            };
        }
        window.addEventListener("scroll", handleScroll);
        return function(param) {
            window.removeEventListener("scroll", handleScroll);
            $2XXXw.removeBreakingPoint(id);
        };
    }, [
        scrollableCtx,
        showPrimaryNavbar
    ]);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(ref)
    });
}
$9c8fd0ed27b0a0bc$var$ScrollRestorationBreaker.displayName = "ScrollRestorationBreaker";
var $9c8fd0ed27b0a0bc$export$dd44f18ab656f3bb = $9c8fd0ed27b0a0bc$var$ScrollRestorationBreaker;
 /* react Not a pure module */ 
});


parcelRegister("dKeuY", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $a01ad15ec1b330ee$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $fEMeF = parcelRequire("fEMeF");

var $heivG = parcelRequire("heivG");

var $7wIsS = parcelRequire("7wIsS");

var $1xf0g = parcelRequire("1xf0g");

var $lybpH = parcelRequire("lybpH");

var $27XcH = parcelRequire("27XcH");

var $hvzQE = parcelRequire("hvzQE");

var $9HioV = parcelRequire("9HioV");

var $2jMpY = parcelRequire("2jMpY");

var $d7Gw8 = parcelRequire("d7Gw8");

var $7lklg = parcelRequire("7lklg");

var $gCzsf = parcelRequire("gCzsf");

var $ceMif = parcelRequire("ceMif");

var $3L2V6 = parcelRequire("3L2V6");

var $5bEXW = parcelRequire("5bEXW");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $iCVlB = parcelRequire("iCVlB");

var $8E2YL = parcelRequire("8E2YL");

var $g3aLS = parcelRequire("g3aLS");

var $7f2rF = parcelRequire("7f2rF");

var $jQE31 = parcelRequire("jQE31");

var $gUsPc = parcelRequire("gUsPc");

var $5RX6O = parcelRequire("5RX6O");

var $ij6do = parcelRequire("ij6do");
function $a01ad15ec1b330ee$var$ListPageToolbar$Content(Props) {
    var category = Props.category;
    var topLevelCategories = Props.topLevelCategories;
    var listPageContentType = Props.listPageContentType;
    var isSidebarOpen = Props.isSidebarOpen;
    var show = Props.show;
    var isBombayshirts = $iCVlB.useIsBombay(undefined);
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    var match$1 = $aSJcu.use(undefined);
    var isMobile = match$1.isMobile;
    var match$2 = $hBcYV.useRouter(undefined);
    var appliedFilters = match$2.productFilters;
    var appliedSort = match$2.productSort;
    var filtersConfig = $2whNH.flatMap(match.transitiveAccount, function(account) {
        return account.filtersConfig2;
    });
    var isForcingPLP = $5RX6O.useCategoryDisplayPriority(category) === /* ProductsFirst */ 1;
    var match$3 = $9pMGg.use(undefined);
    var toggleFiltersPanel = match$3.toggleFiltersPanel;
    var toggleSidebar = match$3.toggleSidebar;
    var match$4 = $g3aLS.use(undefined);
    var isPLP = $lybpH.useIsPLP(undefined);
    var isConnectedToStoreCategory = category !== undefined ? $1xf0g.ExternalConnection.isConnectedToStoreCategory(category) : $2whNH.mapWithDefault(settings.indexNode, false, $1xf0g.ExternalConnection.isConnectedToStoreCategory);
    var match$5 = $hvzQE.isEnabled(category, settings, match$2.listPageType, isForcingPLP);
    var filtersEnabled = match$5[1] && $2whNH.isSome(filtersConfig);
    var shouldShowFilters = (match$5[0] || filtersEnabled) && !isMobile;
    var shouldShowSorts = settings.filtersEnabled && isPLP && !isMobile && isConnectedToStoreCategory;
    var match$6 = settings.indexNode;
    var connection = category !== undefined ? $1xf0g.ExternalConnection.getStoreCategoryConnection(category) : match$6 !== undefined ? $1xf0g.ExternalConnection.getStoreCategoryConnection(match$6) : undefined;
    var match$7 = settings.indexNode;
    var category$1 = category !== undefined ? category : match$7 !== undefined ? match$7 : $ij6do.empty;
    var match$8 = $g3aLS.use(undefined);
    var gridColumns = match$8.gridColumns;
    var shouldShowZoom = match$8.isZoomEnabled && isPLP;
    var zoomButton = $2whNH.map($2whNH.keep(match$4.onChangeGridDensity, function(param) {
        return shouldShowZoom;
    }), function(onChangeGridDensity) {
        return /*#__PURE__*/ $g85JO.createElement($7f2rF.make, {
            value: gridColumns,
            onChange: onChangeGridDensity
        });
    });
    var onClick = isBombayshirts ? function onClick(param) {
        $iv6Yc._1(toggleFiltersPanel, undefined);
    } : function(param) {
        $iv6Yc._1(toggleSidebar, undefined);
    };
    var label = isBombayshirts ? "Filters" : isSidebarOpen ? "Hide Filters" : "Show Filters";
    var filtersButton;
    if (shouldShowFilters) {
        var tmp = {
            onClick: onClick,
            clear: true,
            iconSize: /* Small */ 3,
            labelSize: /* Small */ 3,
            icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilSlidersVAlt.make, {
                size: /* Px */ {
                    _0: 20
                }
            }),
            iconFirst: false,
            noMargin: true,
            label: label,
            dataTestId: "navbar-button-sidebar",
            dataActive: isSidebarOpen,
            iconClassName: $ezf3v.prefix("rotate-90 ml-2 transform-gpu"),
            labelClassName: $ezf3v.prefix("font-medium")
        };
        var tmp$1 = $2whNH.flatMap($2whNH.keep($2whNH.map(appliedFilters, $fEMeF.length), function(num) {
            return num > 0;
        }), function(num) {
            return $2jMpY.fromInt(99, undefined, num);
        });
        if (tmp$1 !== undefined) tmp.badge = $loT9g.valFromOption(tmp$1);
        filtersButton = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($27XcH.make, tmp));
    } else filtersButton = undefined;
    var sortsButton;
    if (shouldShowSorts) {
        var tmp$2 = {
            connection: connection,
            appliedSort: appliedSort
        };
        if (appliedFilters !== undefined) tmp$2.appliedFilters = $loT9g.valFromOption(appliedFilters);
        sortsButton = $loT9g.some(/*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex space-x-6 relative")
        }, /*#__PURE__*/ $g85JO.createElement($d7Gw8.make, tmp$2)));
    } else sortsButton = undefined;
    var tmp$3 = {};
    if (connection !== undefined) tmp$3.connection = $loT9g.valFromOption(connection);
    if (appliedFilters !== undefined) tmp$3.appliedFilters = $loT9g.valFromOption(appliedFilters);
    if (appliedSort !== undefined) tmp$3.appliedSort = $loT9g.valFromOption(appliedSort);
    var filtersBadges = /*#__PURE__*/ $g85JO.createElement($ceMif.make, tmp$3);
    var controls;
    var exit = 0;
    if (zoomButton !== undefined || filtersButton !== undefined || sortsButton !== undefined) exit = 1;
    else controls = undefined;
    if (exit === 1) controls = $loT9g.some(isMobile ? $2whNH.getWithDefault(zoomButton, null) : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex justify-between items-center",
            isPLP ? "gap-7" : ""
        ]))
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex items-center justify-end")
    }, $2whNH.getWithDefault(zoomButton, null)), $2whNH.getWithDefault(filtersButton, null), $2whNH.getWithDefault(sortsButton, null)));
    var breadcrumbs = $9HioV.useBreadcrumbs(true, false, undefined, topLevelCategories);
    var show$1 = show && (isPLP || breadcrumbs.show || $2whNH.isSome(controls));
    var tmp$4;
    if (isPLP) {
        var exit$1 = 0;
        if (typeof listPageContentType === "number") {
            if (listPageContentType !== 1) {
                if (listPageContentType !== 0) exit$1 = 1;
                else tmp$4 = /*#__PURE__*/ $g85JO.createElement($7lklg.make, {
                    minimal: true,
                    text: "Recently Viewed"
                });
            } else tmp$4 = /*#__PURE__*/ $g85JO.createElement($7lklg.make, {
                minimal: true,
                text: "Favorites"
            });
        } else exit$1 = 1;
        if (exit$1 === 1) tmp$4 = /*#__PURE__*/ $g85JO.createElement($3L2V6.make, {
            category: category$1,
            className: $ezf3v.prefix("text-lg float-left text-secondary"),
            format: function format(count) {
                return "" + String(count) + " product" + (count !== 1 ? "s" : "") + "";
            },
            key: category$1.id
        });
    } else tmp$4 = breadcrumbs.show ? /*#__PURE__*/ $g85JO.createElement($9HioV.Show.make, {
        hook: breadcrumbs
    }) : null;
    return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: show$1,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "py-3",
                "bg-main",
                "pointer-events-auto"
            ]))
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "flex",
                "w-full",
                "items-center",
                "justify-between",
                "relative",
                isMobile ? "flex-wrap" : "flex-nowrap",
                isMobile ? "px-4" : "px-8"
            ]))
        }, /*#__PURE__*/ $g85JO.createElement("div", undefined, tmp$4), $2whNH.getWithDefault(controls, null)), filtersBadges)
    });
}
$a01ad15ec1b330ee$var$ListPageToolbar$Content.displayName = "ListPageToolbar.Content";
var $a01ad15ec1b330ee$var$make = /*#__PURE__*/ $g85JO.memo($a01ad15ec1b330ee$var$ListPageToolbar$Content);
var $a01ad15ec1b330ee$export$7c6e2c02157bb7d2 = {
    make: $a01ad15ec1b330ee$var$make
};
function $a01ad15ec1b330ee$var$ListPageToolbar(Props) {
    var showOpt = Props.show;
    var anchorHookResult = Props.anchorHookResult;
    var category = Props.category;
    var listPageContentType = Props.listPageContentType;
    var isSidebarOpen = Props.isSidebarOpen;
    var topLevelCategories = Props.topLevelCategories;
    var show = showOpt !== undefined ? showOpt : true;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $9pMGg.use(undefined);
    var match$2 = $jQE31.Context.use(undefined);
    var match$3 = match$2.state;
    var titleHeight = match$3.titleHeight;
    var subMenuSliderHeight = match$3.subMenuSliderHeight;
    var dynamicSecondaryNavbarHeight = match$3.dynamicSecondaryNavbarHeight;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, topLevelCategories);
    var primaryNavbarHeight = match$3.showPrimaryNavbar ? match$3.primaryNavbarHeight : 0;
    var offsetForStickyElements = $gUsPc.useEffective(undefined);
    var offsetForStickyElements$1 = match$1.embedType === /* Inline */ 1 ? offsetForStickyElements : 0;
    var offset = (primaryNavbarHeight + match$3.fixedSecondaryNavbarHeight | 0) + offsetForStickyElements$1 | 0;
    var ref = $g85JO.useRef(null);
    $jQE31.useToolbarHeightSetter(ref);
    var marginTop = $2whNH.map($2whNH.keep($2whNH.keep($2whNH.keep(-dynamicSecondaryNavbarHeight | 0, function(param) {
        return subMenuSliderHeight !== 0;
    }), function(param) {
        return titleHeight >= dynamicSecondaryNavbarHeight;
    }), function(param) {
        return !isMobile;
    }), $ezf3v.intToPx);
    var match$4 = $2whNH.map(category, function(category) {
        return category.categoryType;
    });
    var needToolbar;
    if (match$4 !== undefined) {
        if (typeof match$4 === "number") needToolbar = false;
        else switch(match$4.TAG | 0){
            case /* CustomComponentSection */ 5:
            case /* EmbedCodeSection */ 6:
                needToolbar = false;
                break;
            default:
                needToolbar = true;
        }
    } else needToolbar = true;
    var tmp = {
        top: $ezf3v.intToPx(offset - 1 | 0)
    };
    if (marginTop !== undefined) tmp.marginTop = marginTop;
    var tmp$1 = {
        topLevelCategories: topLevelCategories,
        activeCategory: activeCategory,
        keepFixed: false
    };
    if (anchorHookResult !== undefined) tmp$1.anchorHookResult = $loT9g.valFromOption(anchorHookResult);
    var tmp$2 = {
        topLevelCategories: topLevelCategories,
        listPageContentType: listPageContentType,
        isSidebarOpen: isSidebarOpen,
        show: show
    };
    if (category !== undefined) tmp$2.category = $loT9g.valFromOption(category);
    return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: needToolbar,
        children: /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            ariaLive: "polite",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                ref: $5bEXW.Ref.domRef(ref),
                "aria-atomic": true,
                className: $ezf3v.prefix($1TRFX.make([
                    "smartnav-toolbar",
                    "sticky",
                    "relative",
                    "w-full",
                    "transition-top duration-300 z-10",
                    "pointer-events-none"
                ])),
                role: "toolbar",
                style: tmp
            }, /*#__PURE__*/ $g85JO.createElement($heivG.SecondaryNavbar.make, tmp$1), /*#__PURE__*/ $g85JO.createElement($a01ad15ec1b330ee$var$make, tmp$2))
        })
    });
}
$a01ad15ec1b330ee$var$ListPageToolbar.displayName = "ListPageToolbar";
var $a01ad15ec1b330ee$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($a01ad15ec1b330ee$var$ListPageToolbar);
 /* make Not a pure module */ 
});
parcelRegister("d7Gw8", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $98dce8d63853e6f8$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $c6E1z = parcelRequire("c6E1z");

var $7wIsS = parcelRequire("7wIsS");

var $1xf0g = parcelRequire("1xf0g");

var $itcSE = parcelRequire("itcSE");

var $aVDGX = parcelRequire("aVDGX");

var $27XcH = parcelRequire("27XcH");

var $2QKwI = parcelRequire("2QKwI");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $kxLPc = parcelRequire("kxLPc");

var $8E2YL = parcelRequire("8E2YL");
function $98dce8d63853e6f8$var$ListPageSort$SortDropDown(Props) {
    var appliedSort = Props.appliedSort;
    var availableSortsOpt = Props.availableSorts;
    var onOpenOpt = Props.onOpen;
    var onCloseOpt = Props.onClose;
    var onChangeSort = Props.onChangeSort;
    var isOpenOpt = Props.isOpen;
    var availableSorts = availableSortsOpt !== undefined ? availableSortsOpt : [];
    var onOpen = onOpenOpt !== undefined ? onOpenOpt : function onOpen(param) {};
    var onClose = onCloseOpt !== undefined ? onCloseOpt : function onClose(param) {};
    var isOpen = isOpenOpt !== undefined ? isOpenOpt : false;
    var match = $aSJcu.use(undefined);
    var estimatedDropdownHeight = Math.min(12 + Math.imul(availableSorts.length, 35) | 0, 350);
    var options = $i7mYY.mapWithIndex(availableSorts, function(index, availableSort) {
        var title = availableSort[0];
        return {
            id: title,
            index: index,
            facet: "",
            label: title,
            swatch: undefined,
            value: appliedSort === availableSort[1],
            count: 0,
            disabled: false
        };
    });
    var section = {
        label: "Sort by",
        id: "sorts",
        options: options,
        style: /* Radio */ 5,
        visible: true
    };
    var getSortOptionFromSelections = function getSortOptionFromSelections(selections) {
        return $2whNH.map($i7mYY.getBy(availableSorts, function(param) {
            return param[0] === $2whNH.map($i7mYY.get($i7mYY.keep(selections, function(f) {
                return f.value;
            }), 0), function(f) {
                return f.label;
            });
        }), function(param) {
            return param[1];
        });
    };
    return /*#__PURE__*/ $g85JO.createElement($itcSE.make, {
        isOpen: isOpen,
        onOpen: onOpen,
        onClose: onClose,
        children: /*#__PURE__*/ $g85JO.createElement($2QKwI.make, {
            section: section,
            showLabel: false,
            canCollapse: false,
            border: false,
            onChange: function onChange(selections) {
                $iv6Yc._1(onChangeSort, getSortOptionFromSelections(selections));
            },
            autoFocus: isOpen,
            large: match.isMobile,
            className: $ezf3v.prefix("w-full relative"),
            rtl: true,
            sectionIdPrefix: "sorts"
        }),
        className: $ezf3v.prefix("mt-2"),
        label: "Sort",
        height: estimatedDropdownHeight
    });
}
$98dce8d63853e6f8$var$ListPageSort$SortDropDown.displayName = "ListPageSort.SortDropDown";
var $98dce8d63853e6f8$export$c5a236f3831835b7 = {
    make: $98dce8d63853e6f8$var$ListPageSort$SortDropDown
};
function $98dce8d63853e6f8$export$d6de786fe8e285cc(sort) {
    return [
        $kxLPc.humanizeSort(sort),
        sort
    ];
}
function $98dce8d63853e6f8$var$ListPageSort(Props) {
    var categoryId = Props.categoryId;
    var connection = Props.connection;
    var appliedSort = Props.appliedSort;
    var appliedFilters = Props.appliedFilters;
    var match = $9pMGg.use(undefined);
    var trackEvent = match.trackEvent;
    var match$1 = $8E2YL.use(undefined).config;
    var account = match$1.transitiveAccount;
    var match$2 = $g85JO.useState(function() {
        return false;
    });
    var _setIsDropdownOpen = match$2[1];
    var isDropdownOpen = match$2[0];
    var setIsDropdownOpen = function setIsDropdownOpen(callback) {
        $iv6Yc._1(_setIsDropdownOpen, function(isDropdownOpen) {
            var result = $iv6Yc._1(callback, isDropdownOpen);
            if (result) $iv6Yc.app(trackEvent, [
                "sort expanded",
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
            return result;
        });
    };
    var defaultFilters = $2whNH.flatMap(connection, function(connection) {
        return $1xf0g.ExternalConnection.getFilterBy(connection, account);
    });
    var match$3 = $c6E1z.useCategoryProducts(undefined, match$1.transitiveStoreId, categoryId, connection, match$1.settings.hideOutOfStock, appliedFilters, defaultFilters, undefined, appliedSort, true, match.smartnavApiHost, undefined, match.market, undefined);
    var swr = match$3.swr;
    var availableSorts = $2whNH.flatMap($2whNH.flatMap(swr.data, function(data) {
        return $i7mYY.get(data, 0);
    }), function(page) {
        return page.availableSorts;
    });
    var categoryDefaultSort = $2whNH.flatMap($2whNH.flatMap(swr.data, function(data) {
        return $i7mYY.get(data, 0);
    }), function(page) {
        return page.defaultSortOrder;
    });
    var match$4 = $aVDGX.useSorts(appliedSort, categoryDefaultSort, availableSorts, connection);
    var appliedSort$1 = match$4[0];
    appliedSort$1 !== undefined ? appliedSort$1 !== 0 || categoryDefaultSort === undefined ? appliedSort$1 : categoryDefaultSort !== 0 ? categoryDefaultSort : undefined : categoryDefaultSort !== undefined && categoryDefaultSort !== 0 ? categoryDefaultSort : undefined;
    var label = "Sort";
    var dropdown = /*#__PURE__*/ $g85JO.createElement($98dce8d63853e6f8$var$ListPageSort$SortDropDown, {
        appliedSort: appliedSort$1,
        availableSorts: match$4[1],
        onOpen: function onOpen(param) {
            setIsDropdownOpen(function(param) {
                return true;
            });
        },
        onClose: function onClose(param) {
            setIsDropdownOpen(function(param) {
                return false;
            });
        },
        onChangeSort: match.onChangeSort,
        isOpen: isDropdownOpen
    });
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($27XcH.make, {
        onMouseDown: function onMouseDown(param) {
            setIsDropdownOpen(function(param) {
                return !isDropdownOpen;
            });
        },
        clear: true,
        iconSize: /* Small */ 3,
        labelSize: /* Small */ 3,
        icon: /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleLeftB.make, {
            size: /* Px */ {
                _0: 20
            }
        }),
        iconFirst: false,
        noMargin: true,
        label: label,
        dataTestId: "plp-sort-button",
        dataActive: isDropdownOpen,
        iconClassName: $ezf3v.prefix($1TRFX.make([
            isDropdownOpen ? "rotate-90" : "-rotate-90",
            "ml-2 transform-gpu w-7 h-7"
        ])),
        labelClassName: $ezf3v.prefix("font-medium")
    }), dropdown);
}
$98dce8d63853e6f8$var$ListPageSort.displayName = "ListPageSort";
var $98dce8d63853e6f8$export$dd44f18ab656f3bb = $98dce8d63853e6f8$var$ListPageSort;
 /* react Not a pure module */ 
});
parcelRegister("itcSE", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $d724ed3dee0296dd$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $5alaa = parcelRequire("5alaa");

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $5iu1A = parcelRequire("5iu1A");

var $5bEXW = parcelRequire("5bEXW");

var $aSJcu = parcelRequire("aSJcu");

var $iJp5F = parcelRequire("iJp5F");
function $d724ed3dee0296dd$export$cd4e5573fbe2b576(param) {
    return document.activeElement;
}
function $d724ed3dee0296dd$var$Dropdown(Props) {
    var isOpenOpt = Props.isOpen;
    var mobileOpt = Props.mobile;
    var onOpen = Props.onOpen;
    var onClose = Props.onClose;
    var children = Props.children;
    var classNameOpt = Props.className;
    var label = Props.label;
    var heightOpt = Props.height;
    var widthOpt = Props.width;
    var isOpen = isOpenOpt !== undefined ? isOpenOpt : false;
    var mobile = mobileOpt !== undefined ? mobileOpt : true;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var height = heightOpt !== undefined ? heightOpt : 192;
    var width = widthOpt !== undefined ? widthOpt : 192;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile && mobile;
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setOpen = match$1[1];
    var match$2 = $g85JO.useState(function() {
        return String($5alaa.random_int(1000, 9999));
    });
    var identifierClassName = "sn-dropdown-" + match$2[0];
    var match$3 = $g85JO.useState(function() {
        return false;
    });
    var setHorizontalFlip = match$3[1];
    var ref = $g85JO.useRef(null);
    var domRef = $5bEXW.Ref.domRef(ref);
    var intersection = $iJp5F.use(ref, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    $g85JO.useEffect(function() {
        var i = intersection.intersectionRect;
        if (i !== undefined) {
            var b = intersection.boundingClientRect;
            if (b !== undefined) {
                var r = intersection.rootBounds;
                if (r !== undefined) {
                    var i$1 = $loT9g.valFromOption(i);
                    var horizontalFlip = i$1.x + i$1.width > $loT9g.valFromOption(r).width || $loT9g.valFromOption(b).x < 0.0;
                    $iv6Yc._1(setHorizontalFlip, function(param) {
                        return horizontalFlip;
                    });
                }
            }
        }
    }, [
        intersection
    ]);
    $g85JO.useEffect(function() {
        $iv6Yc._1(setOpen, function(param) {
            return isOpen;
        });
    }, [
        isOpen
    ]);
    var matchesActiveElement = function matchesActiveElement(el) {
        var activeEl = $d724ed3dee0296dd$export$cd4e5573fbe2b576(undefined);
        var activeElClassName = $2whNH.map(activeEl, function(el) {
            return el.className;
        });
        if ($7bjme.equal(el.className, activeElClassName)) return true;
        else return el.contains(activeEl);
    };
    var onFocus = function onFocus(param) {
        var el = ref.current;
        if (!(el == null) && matchesActiveElement(el)) return $iv6Yc._1(onOpen, undefined);
    };
    var onBlur = function onBlur(param) {
        var el = ref.current;
        if (!(el == null) && !matchesActiveElement(el)) return $iv6Yc._1(onClose, undefined);
    };
    var style = {
        height: $ezf3v.intToPx(isOpen ? height : 0),
        width: $ezf3v.intToPx(width),
        zIndex: "1"
    };
    if (isMobile) {
        var tmp = {
            children: children,
            isOpen: isOpen,
            onClose: onClose,
            fullWidth: true,
            unmount: false
        };
        if (label !== undefined) tmp.label = $loT9g.valFromOption(label);
        return /*#__PURE__*/ $g85JO.createElement($5iu1A.make, tmp);
    }
    var tmp$1 = {
        ref: domRef,
        "aria-hidden": !isOpen,
        "aria-modal": true,
        className: $1TRFX.make([
            identifierClassName,
            $ezf3v.prefix("flex transition-all duration-200 ease-in-out rounded-md bg-main px-6 absolute overflow-y-auto overflow-x-hidden"),
            $ezf3v.prefix(isOpen ? "shadow-xl pt-5" : "pt-0 shadow-none"),
            $ezf3v.prefix(match$3[0] ? "left-0" : "right-0"),
            $ezf3v.prefix("top-full"),
            className
        ]),
        role: "dialog",
        style: style,
        tabIndex: 0,
        onFocus: onFocus,
        onBlur: onBlur
    };
    if (label !== undefined) tmp$1["aria-label"] = $loT9g.valFromOption(label);
    return /*#__PURE__*/ $g85JO.createElement("div", tmp$1, children);
}
$d724ed3dee0296dd$var$Dropdown.displayName = "Dropdown";
var $d724ed3dee0296dd$export$dd44f18ab656f3bb = $d724ed3dee0296dd$var$Dropdown;
 /* react Not a pure module */ 
});


parcelRegister("3L2V6", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $2bc806bfaf7310a4$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $c6E1z = parcelRequire("c6E1z");

var $1xf0g = parcelRequire("1xf0g");

var $dMhWy = parcelRequire("dMhWy");

var $hBcYV = parcelRequire("hBcYV");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $6EwcS = parcelRequire("6EwcS");
function $2bc806bfaf7310a4$var$ProductsCount(Props) {
    var category = Props.category;
    var className = Props.className;
    var format = Props.format;
    var match = $hBcYV.useRouter(undefined);
    var favorites = $dMhWy.useFavorites(undefined);
    var match$1 = $6EwcS.use(undefined);
    var defaultFormat = function defaultFormat(prim) {
        return String(prim);
    };
    var format$1 = $2whNH.getWithDefault(format, defaultFormat);
    var match$2 = $8E2YL.use(undefined);
    var match$3 = match$2.config;
    var account = match$3.transitiveAccount;
    var match$4 = $9pMGg.use(undefined);
    var defaultFilters = $2whNH.flatMap($1xf0g.ExternalConnection.getStoreCategoryConnection(category), function(connection) {
        return $1xf0g.ExternalConnection.getFilterBy(connection, account);
    });
    var match$5 = $c6E1z.useCategoryProducts(undefined, match$3.transitiveStoreId, category.id, $1xf0g.ExternalConnection.getStoreCategoryConnection(category), match$3.settings.hideOutOfStock, match.productFilters, defaultFilters, undefined, match.productSort, true, match$4.smartnavApiHost, undefined, match$4.market, undefined);
    var totalValue = $2whNH.flatMap($2whNH.flatMap(match$5.swr.data, function(data) {
        return $i7mYY.get(data, 0);
    }), function(page) {
        return page.total;
    });
    var match$6 = $1xf0g.ExternalConnection.getConnection(category);
    var totalValue$1;
    if (match$6 !== undefined && typeof match$6 === "number") switch(match$6){
        case /* History */ 0:
            totalValue$1 = match$1.history.value.length;
            break;
        case /* Favorites */ 1:
            totalValue$1 = favorites.count;
            break;
        case /* StoreCart */ 2:
            totalValue$1 = undefined;
            break;
    }
    else totalValue$1 = totalValue;
    var match$7 = $1xf0g.ExternalConnection.getStoreCategoryConnection(category);
    var fallbackCount = match$7 !== undefined ? match$7.count : $1xf0g.getProducts(category).length;
    var match$8 = $g85JO.useState(function() {
        return totalValue$1;
    });
    var setTotal = match$8[1];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setTotal, function(previous) {
            return $2whNH.orElse(totalValue$1, previous);
        });
    }, [
        totalValue$1
    ]);
    var count = $2whNH.getWithDefault(match$8[0], fallbackCount);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $1TRFX.make([
            $2whNH.getWithDefault(className, ""),
            $2whNH.isNone(totalValue$1) ? $ezf3v.prefix("opacity-50") : ""
        ])
    }, $iv6Yc._1(format$1, count));
}
$2bc806bfaf7310a4$var$ProductsCount.displayName = "ProductsCount";
var $2bc806bfaf7310a4$export$dd44f18ab656f3bb = $2bc806bfaf7310a4$var$ProductsCount;
 /* react Not a pure module */ 
});

parcelRegister("7f2rF", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $545bd4ac98964ea1$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $ezf3v = parcelRequire("ezf3v");

var $g7YfO = parcelRequire("g7YfO");

var $aSJcu = parcelRequire("aSJcu");

var $g3aLS = parcelRequire("g3aLS");
function $545bd4ac98964ea1$var$GridDensityZoomSelector(Props) {
    var value = Props.value;
    var onChange = Props.onChange;
    $aSJcu.use(undefined);
    var match = $g3aLS.use(undefined);
    var getAriaLabel = function getAriaLabel(gridColumn) {
        switch(gridColumn){
            case /* OneColumnGrid */ 0:
                return "One Column";
            case /* TwoColumnGrid */ 1:
                return "Two Columns";
            case /* ThreeColumnGrid */ 2:
                return "Three Columns";
            case /* FourColumnGrid */ 3:
                return "Four Columns";
            case /* FiveColumnGrid */ 4:
                return "Five Columns";
            case /* SixColumnGrid */ 5:
                return "Six Columns";
            case /* SevenColumnGrid */ 6:
                return "Seven Columns";
            case /* EightColumnGrid */ 7:
                return "Eight Columns";
            case /* TwelveColumnGrid */ 8:
                return "Twelve Columns";
        }
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("inline-flex")
    }, $i7mYY.map(match.options, function(option) {
        var active = option === value;
        var tmp;
        var exit = 0;
        switch(option){
            case /* OneColumnGrid */ 0:
                tmp = /*#__PURE__*/ $g85JO.createElement($g7YfO.SizeOne.make, {
                    className: $ezf3v.prefix("w-7 h-7"),
                    active: active
                });
                break;
            case /* TwoColumnGrid */ 1:
                tmp = /*#__PURE__*/ $g85JO.createElement($g7YfO.SizeTwo.make, {
                    className: $ezf3v.prefix("w-7 h-7"),
                    active: active
                });
                break;
            case /* ThreeColumnGrid */ 2:
                tmp = /*#__PURE__*/ $g85JO.createElement($g7YfO.SizeThree.make, {
                    className: $ezf3v.prefix("w-7 h-7"),
                    active: active
                });
                break;
            case /* FourColumnGrid */ 3:
                tmp = /*#__PURE__*/ $g85JO.createElement($g7YfO.SizeFour.make, {
                    className: $ezf3v.prefix("w-7 h-7"),
                    active: active
                });
                break;
            case /* FiveColumnGrid */ 4:
            case /* SixColumnGrid */ 5:
            case /* SevenColumnGrid */ 6:
            case /* EightColumnGrid */ 7:
            case /* TwelveColumnGrid */ 8:
                exit = 1;
                break;
        }
        if (exit === 1) tmp = /*#__PURE__*/ $g85JO.createElement($g7YfO.SizeFive.make, {
            className: $ezf3v.prefix("w-7 h-7"),
            active: active
        });
        return /*#__PURE__*/ $g85JO.createElement("button", {
            "aria-label": getAriaLabel(option),
            "aria-selected": active,
            className: $ezf3v.prefix($1TRFX.make([
                "bg-transparent p-1 cursor-pointer",
                active ? "text-primary" : "text-secondary hover:text-primary"
            ])),
            title: getAriaLabel(option),
            onClick: function onClick(param) {
                return $iv6Yc._1(onChange, option);
            }
        }, tmp);
    }));
}
$545bd4ac98964ea1$var$GridDensityZoomSelector.displayName = "GridDensityZoomSelector";
var $545bd4ac98964ea1$export$dd44f18ab656f3bb = $545bd4ac98964ea1$var$GridDensityZoomSelector;
 /* react Not a pure module */ 
});
parcelRegister("g7YfO", function(module, exports) {

$parcel$export(module.exports, "SizeOne", function () { return $bbdc09fcfb1cb0ad$export$e6c83774ff491196; });
$parcel$export(module.exports, "SizeTwo", function () { return $bbdc09fcfb1cb0ad$export$ee41e30fb17e0b5; });
$parcel$export(module.exports, "SizeThree", function () { return $bbdc09fcfb1cb0ad$export$73909695da332f49; });
$parcel$export(module.exports, "SizeFour", function () { return $bbdc09fcfb1cb0ad$export$1bf6ec9ae997e861; });
$parcel$export(module.exports, "SizeFive", function () { return $bbdc09fcfb1cb0ad$export$5f82cf980f7213c6; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeOne(Props) {
    var className = Props.className;
    var active = Props.active;
    if (active) {
        var tmp = {
            height: "24",
            width: "24",
            fill: "none",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        };
        if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
        return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
            d: "M1.5 1.5H22.5V22.5H1.5V1.5Z",
            fill: "currentColor"
        }));
    }
    var tmp$1 = {
        height: "24",
        width: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp$1.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp$1, /*#__PURE__*/ $g85JO.createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M21 3H3V21H21V3ZM3 1.5H21H22.5V3V21V22.5H21H3H1.5V21V3V1.5H3Z",
        fill: "currentColor"
    })));
}
$bbdc09fcfb1cb0ad$var$IconGridSizes$SizeOne.displayName = "IconGridSizes.SizeOne";
var $bbdc09fcfb1cb0ad$export$e6c83774ff491196 = {
    make: $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeOne
};
function $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeTwo(Props) {
    var className = Props.className;
    var active = Props.active;
    if (active) {
        var tmp = {
            height: "24",
            width: "24",
            fill: "none",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        };
        if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
        return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
            d: "M10.5 1.5V10.5H1.5V1.5H10.5ZM10.5 13.5V22.5H1.5V13.5H10.5ZM13.5 1.5H22.5V10.5H13.5V1.5ZM22.5 13.5V22.5H13.5V13.5H22.5Z",
            fill: "currentColor"
        }));
    }
    var tmp$1 = {
        height: "24",
        width: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp$1.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp$1, /*#__PURE__*/ $g85JO.createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M3 3V9H9V3H3ZM1.5 1.5H3H9H10.5V3V9V10.5H9H3H1.5V9V3V1.5ZM3 15V21H9V15H3ZM1.5 13.5H3H9H10.5V15V21V22.5H9H3H1.5V21V15V13.5ZM21 3H15V9H21V3ZM15 1.5H21H22.5V3V9V10.5H21H15H13.5V9V3V1.5H15ZM15 15V21H21V15H15ZM13.5 13.5H15H21H22.5V15V21V22.5H21H15H13.5V21V15V13.5Z",
        fill: "currentColor"
    })));
}
$bbdc09fcfb1cb0ad$var$IconGridSizes$SizeTwo.displayName = "IconGridSizes.SizeTwo";
var $bbdc09fcfb1cb0ad$export$ee41e30fb17e0b5 = {
    make: $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeTwo
};
function $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeThree(Props) {
    var className = Props.className;
    var active = Props.active;
    if (active) {
        var tmp = {
            height: "24",
            width: "24",
            fill: "none",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        };
        if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
        return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
            d: "M1.5 1.5H7.5V7.5H1.5V1.5ZM1.5 9H7.5V15H1.5V9ZM7.5 16.5V22.5H1.5V16.5H7.5ZM9 1.5H15V7.5H9V1.5ZM15 9V15H9V9H15ZM9 16.5H15V22.5H9V16.5ZM22.5 1.5V7.5H16.5V1.5H22.5ZM16.5 9H22.5V15H16.5V9ZM22.5 16.5V22.5H16.5V16.5H22.5Z",
            fill: "currentColor"
        }));
    }
    var tmp$1 = {
        height: "24",
        width: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp$1.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp$1, /*#__PURE__*/ $g85JO.createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M6 3H3V6H6V3ZM3 1.5H6H7.5V3V6V7.5H6H3H1.5V6V3V1.5H3ZM6 10.5H3V13.5H6V10.5ZM3 9H6H7.5V10.5V13.5V15H6H3H1.5V13.5V10.5V9H3ZM3 18V21H6V18H3ZM1.5 16.5H3H6H7.5V18V21V22.5H6H3H1.5V21V18V16.5ZM13.5 3H10.5V6H13.5V3ZM10.5 1.5H13.5H15V3V6V7.5H13.5H10.5H9V6V3V1.5H10.5ZM10.5 10.5V13.5H13.5V10.5H10.5ZM9 9H10.5H13.5H15V10.5V13.5V15H13.5H10.5H9V13.5V10.5V9ZM13.5 18H10.5V21H13.5V18ZM10.5 16.5H13.5H15V18V21V22.5H13.5H10.5H9V21V18V16.5H10.5ZM18 3V6H21V3H18ZM16.5 1.5H18H21H22.5V3V6V7.5H21H18H16.5V6V3V1.5ZM21 10.5H18V13.5H21V10.5ZM18 9H21H22.5V10.5V13.5V15H21H18H16.5V13.5V10.5V9H18ZM18 18V21H21V18H18ZM16.5 16.5H18H21H22.5V18V21V22.5H21H18H16.5V21V18V16.5Z",
        fill: "currentColor"
    })));
}
$bbdc09fcfb1cb0ad$var$IconGridSizes$SizeThree.displayName = "IconGridSizes.SizeThree";
var $bbdc09fcfb1cb0ad$export$73909695da332f49 = {
    make: $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeThree
};
function $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeFour(Props) {
    var className = Props.className;
    var active = Props.active;
    if (active) {
        var tmp = {
            height: "24",
            width: "24",
            fill: "none",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        };
        if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
        return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
            d: "M1.5 1.5H5.67188V5.71875H1.5V1.5ZM1.5 7.125H5.67188V11.3438H1.5V7.125ZM5.67188 12.7031V16.9219H1.5V12.7031H5.67188ZM1.5 18.3281H5.67188V22.5H1.5V18.3281ZM7.07812 1.5H11.2969V5.71875H7.07812V1.5ZM7.07812 7.125H11.2969V11.3438H7.07812V7.125ZM11.2969 12.7031V16.9219H7.07812V12.7031H11.2969ZM7.07812 18.3281H11.2969V22.5H7.07812V18.3281ZM16.875 1.5V5.71875H12.6562V1.5H16.875ZM16.875 7.125V11.3438H12.6562V7.125H16.875ZM12.6562 12.7031H16.875V16.9219H12.6562V12.7031ZM16.875 18.3281V22.5H12.6562V18.3281H16.875ZM18.2812 1.5H22.5V5.71875H18.2812V1.5ZM18.2812 7.125H22.5V11.3438H18.2812V7.125ZM22.5 12.7031V16.9219H18.2812V12.7031H22.5ZM18.2812 18.3281H22.5V22.5H18.2812V18.3281Z",
            fill: "currentColor"
        }));
    }
    var tmp$1 = {
        height: "24",
        width: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp$1.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp$1, /*#__PURE__*/ $g85JO.createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M2.625 2.625V4.59375H4.54688V2.625H2.625ZM2.625 8.25V10.2188H4.54688V8.25H2.625ZM1.5 12.7031H2.625H4.54688H5.67188V13.8281V15.7969V16.9219H4.54688H2.625H1.5V15.7969V13.8281V12.7031ZM4.54688 15.7969V13.8281H2.625V15.7969H4.54688ZM2.625 19.4531V21.375H4.54688V19.4531H2.625ZM5.67188 1.5V2.625V4.59375V5.71875H4.54688H2.625H1.5V4.59375V2.625V1.5H2.625H4.54688H5.67188ZM5.67188 7.125V8.25V10.2188V11.3438H4.54688H2.625H1.5V10.2188V8.25V7.125H2.625H4.54688H5.67188ZM5.67188 18.3281V19.4531V21.375V22.5H4.54688H2.625H1.5V21.375V19.4531V18.3281H2.625H4.54688H5.67188ZM8.20312 2.625V4.59375H10.1719V2.625H8.20312ZM8.20312 8.25V10.2188H10.1719V8.25H8.20312ZM7.07812 12.7031H8.20312H10.1719H11.2969V13.8281V15.7969V16.9219H10.1719H8.20312H7.07812V15.7969V13.8281V12.7031ZM10.1719 15.7969V13.8281H8.20312V15.7969H10.1719ZM8.20312 19.4531V21.4219H10.1719V19.4531H8.20312ZM11.2969 1.5V2.625V4.59375V5.71875H10.1719H8.20312H7.07812V4.59375V2.625V1.5H8.20312H10.1719H11.2969ZM11.2969 7.125V8.25V10.2188V11.3438H10.1719H8.20312H7.07812V10.2188V8.25V7.125H8.20312H10.1719H11.2969ZM11.2969 18.3281V19.4531V21.375V22.5H10.1719H8.20312H7.07812V21.375V19.4531V18.3281H8.20312H10.1719H11.2969ZM15.75 2.625H13.7812V4.59375H15.75V2.625ZM15.75 8.25H13.7812V10.2188H15.75V8.25ZM12.6562 13.8281V12.7031H13.7812H15.75H16.875V13.8281V15.7969V16.9219H15.75H13.7812H12.6562V15.7969V13.8281ZM13.7812 15.7969H15.75V13.8281H13.7812V15.7969ZM15.75 19.4531H13.7812V21.375H15.75V19.4531ZM15.75 1.5H16.875V2.625V4.59375V5.71875H15.75H13.7812H12.6562V4.59375V2.625V1.5H13.7812H15.75ZM15.75 7.125H16.875V8.25V10.2188V11.3438H15.75H13.7812H12.6562V10.2188V8.25V7.125H13.7812H15.75ZM15.75 18.3281H16.875V19.4531V21.375V22.5H15.75H13.7812H12.6562V21.375V19.4531V18.3281H13.7812H15.75ZM19.4062 2.625V4.59375H21.375V2.625H19.4062ZM19.4062 8.25V10.2188H21.375V8.25H19.4062ZM18.2812 12.7031H19.4062H21.375H22.5V13.8281V15.7969V16.9219H21.375H19.4062H18.2812V15.7969V13.8281V12.7031ZM21.375 15.7969V13.8281H19.4062V15.7969H21.375ZM19.4062 19.4531V21.375H21.375V19.4531H19.4062ZM22.5 1.5V2.625V4.59375V5.71875H21.375H19.4062H18.2812V4.59375V2.625V1.5H19.4062H21.375H22.5ZM22.5 7.125V8.25V10.2188V11.3438H21.375H19.4062H18.2812V10.2188V8.25V7.125H19.4062H21.375H22.5ZM22.5 18.3281V19.4531V21.375V22.5H21.375H19.4062H18.2812V21.375V19.4531V18.3281H19.4062H21.375H22.5Z",
        fill: "currentColor"
    })));
}
$bbdc09fcfb1cb0ad$var$IconGridSizes$SizeFour.displayName = "IconGridSizes.SizeFour";
var $bbdc09fcfb1cb0ad$export$1bf6ec9ae997e861 = {
    make: $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeFour
};
function $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeFive(Props) {
    var className = Props.className;
    var active = Props.active;
    if (active) {
        var tmp = {
            height: "24",
            width: "24",
            fill: "none",
            viewBox: "0 0 24 24",
            xmlns: "http://www.w3.org/2000/svg"
        };
        if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
        return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
            d: "M1.5 1.5H4.5V4.5H1.5V1.5ZM1.5 6H4.5V9H1.5V6ZM4.5 10.5V13.5H1.5V10.5H4.5ZM1.5 15H4.5V18H1.5V15ZM4.5 19.5V22.5H1.5V19.5H4.5ZM6 1.5H9V4.5H6V1.5ZM9 6V9H6V6H9ZM6 10.5H9V13.5H6V10.5ZM9 15V18H6V15H9ZM6 19.5H9V22.5H6V19.5ZM13.5 1.5V4.5H10.5V1.5H13.5ZM10.5 6H13.5V9H10.5V6ZM13.5 10.5V13.5H10.5V10.5H13.5ZM10.5 15H13.5V18H10.5V15ZM13.5 19.5V22.5H10.5V19.5H13.5ZM15 1.5H18V4.5H15V1.5ZM18 6V9H15V6H18ZM15 10.5H18V13.5H15V10.5ZM18 15V18H15V15H18ZM15 19.5H18V22.5H15V19.5ZM22.5 1.5V4.5H19.5V1.5H22.5ZM19.5 6H22.5V9H19.5V6ZM22.5 10.5V13.5H19.5V10.5H22.5ZM19.5 15H22.5V18H19.5V15ZM22.5 19.5V22.5H19.5V19.5H22.5Z",
            fill: "currentColor"
        }));
    }
    var tmp$1 = {
        height: "24",
        width: "24",
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp$1.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp$1, /*#__PURE__*/ $g85JO.createElement("g", {
        opacity: "0.5"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M3.375 2.625H2.625V3.375H3.375V2.625ZM2.625 1.5H3.375H4.5V2.625V3.375V4.5H3.375H2.625H1.5V3.375V2.625V1.5H2.625ZM3.375 7.125H2.625V7.875H3.375V7.125ZM2.625 6H3.375H4.5V7.125V7.875V9H3.375H2.625H1.5V7.875V7.125V6H2.625ZM2.625 11.625V12.375H3.375V11.625H2.625ZM1.5 10.5H2.625H3.375H4.5V11.625V12.375V13.5H3.375H2.625H1.5V12.375V11.625V10.5ZM3.375 16.125H2.625V16.875H3.375V16.125ZM2.625 15H3.375H4.5V16.125V16.875V18H3.375H2.625H1.5V16.875V16.125V15H2.625ZM2.625 20.625V21.375H3.375V20.625H2.625ZM1.5 19.5H2.625H3.375H4.5V20.625V21.375V22.5H3.375H2.625H1.5V21.375V20.625V19.5ZM7.875 2.625H7.125V3.375H7.875V2.625ZM7.125 1.5H7.875H9V2.625V3.375V4.5H7.875H7.125H6V3.375V2.625V1.5H7.125ZM7.125 7.125V7.875H7.875V7.125H7.125ZM6 6H7.125H7.875H9V7.125V7.875V9H7.875H7.125H6V7.875V7.125V6ZM7.875 11.625H7.125V12.375H7.875V11.625ZM7.125 10.5H7.875H9V11.625V12.375V13.5H7.875H7.125H6V12.375V11.625V10.5H7.125ZM7.125 16.125V16.875H7.875V16.125H7.125ZM6 15H7.125H7.875H9V16.125V16.875V18H7.875H7.125H6V16.875V16.125V15ZM7.875 20.625H7.125V21.375H7.875V20.625ZM7.125 19.5H7.875H9V20.625V21.375V22.5H7.875H7.125H6V21.375V20.625V19.5H7.125ZM11.625 2.625V3.375H12.375V2.625H11.625ZM10.5 1.5H11.625H12.375H13.5V2.625V3.375V4.5H12.375H11.625H10.5V3.375V2.625V1.5ZM12.375 7.125H11.625V7.875H12.375V7.125ZM11.625 6H12.375H13.5V7.125V7.875V9H12.375H11.625H10.5V7.875V7.125V6H11.625ZM11.625 11.625V12.375H12.375V11.625H11.625ZM10.5 10.5H11.625H12.375H13.5V11.625V12.375V13.5H12.375H11.625H10.5V12.375V11.625V10.5ZM12.375 16.125H11.625V16.875H12.375V16.125ZM11.625 15H12.375H13.5V16.125V16.875V18H12.375H11.625H10.5V16.875V16.125V15H11.625ZM11.625 20.625V21.375H12.375V20.625H11.625ZM10.5 19.5H11.625H12.375H13.5V20.625V21.375V22.5H12.375H11.625H10.5V21.375V20.625V19.5ZM16.875 2.625H16.125V3.375H16.875V2.625ZM16.125 1.5H16.875H18V2.625V3.375V4.5H16.875H16.125H15V3.375V2.625V1.5H16.125ZM16.125 7.125V7.875H16.875V7.125H16.125ZM15 6H16.125H16.875H18V7.125V7.875V9H16.875H16.125H15V7.875V7.125V6ZM16.875 11.625H16.125V12.375H16.875V11.625ZM16.125 10.5H16.875H18V11.625V12.375V13.5H16.875H16.125H15V12.375V11.625V10.5H16.125ZM16.125 16.125V16.875H16.875V16.125H16.125ZM15 15H16.125H16.875H18V16.125V16.875V18H16.875H16.125H15V16.875V16.125V15ZM16.875 20.625H16.125V21.375H16.875V20.625ZM16.125 19.5H16.875H18V20.625V21.375V22.5H16.875H16.125H15V21.375V20.625V19.5H16.125ZM20.625 2.625V3.375H21.375V2.625H20.625ZM19.5 1.5H20.625H21.375H22.5V2.625V3.375V4.5H21.375H20.625H19.5V3.375V2.625V1.5ZM21.375 7.125H20.625V7.875H21.375V7.125ZM20.625 6H21.375H22.5V7.125V7.875V9H21.375H20.625H19.5V7.875V7.125V6H20.625ZM20.625 11.625V12.375H21.375V11.625H20.625ZM19.5 10.5H20.625H21.375H22.5V11.625V12.375V13.5H21.375H20.625H19.5V12.375V11.625V10.5ZM21.375 16.125H20.625V16.875H21.375V16.125ZM20.625 15H21.375H22.5V16.125V16.875V18H21.375H20.625H19.5V16.875V16.125V15H20.625ZM20.625 20.625V21.375H21.375V20.625H20.625ZM19.5 19.5H20.625H21.375H22.5V20.625V21.375V22.5H21.375H20.625H19.5V21.375V20.625V19.5Z",
        fill: "currentColor"
    })));
}
$bbdc09fcfb1cb0ad$var$IconGridSizes$SizeFive.displayName = "IconGridSizes.SizeFive";
var $bbdc09fcfb1cb0ad$export$5f82cf980f7213c6 = {
    make: $bbdc09fcfb1cb0ad$var$IconGridSizes$SizeFive
};
 /* react Not a pure module */ 
});



parcelRegister("v7lDW", function(module, exports) {

$parcel$export(module.exports, "preload", function () { return $05d8988abe0a4403$export$513ccb98c53b8039; });
$parcel$export(module.exports, "make", function () { return $05d8988abe0a4403$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $loT9g = parcelRequire("loT9g");

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $05d8988abe0a4403$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("kxypM"));
});
function $05d8988abe0a4403$var$FiltersPanel_Lazy(Props) {
    var spacerDivOpt = Props.spacerDiv;
    var childrenOpt = Props.children;
    if (spacerDivOpt !== undefined) $loT9g.valFromOption(spacerDivOpt);
    if (childrenOpt !== undefined) $loT9g.valFromOption(childrenOpt);
    return /*#__PURE__*/ $g85JO.createElement($05d8988abe0a4403$var$component, Props);
}
$05d8988abe0a4403$var$FiltersPanel_Lazy.displayName = "FiltersPanel_Lazy";
var $05d8988abe0a4403$export$513ccb98c53b8039 = $05d8988abe0a4403$var$component.preload;
var $05d8988abe0a4403$export$dd44f18ab656f3bb = $05d8988abe0a4403$var$FiltersPanel_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("kxypM", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("gORIA")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("eybsM"))
]).then(function() {
    return parcelRequire("4e7E6");
});

});


parcelRegister("9zTTJ", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $6f92be1a792eb479$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $fvE4w = parcelRequire("fvE4w");

var $4XxBe = parcelRequire("4XxBe");

var $fCPBg = parcelRequire("fCPBg");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");
function $6f92be1a792eb479$var$ListPageMobileNavbar(Props) {
    var scrollableContainerRef = Props.scrollableContainerRef;
    var match = $aSJcu.use(undefined);
    var match$1 = $9pMGg.use(undefined);
    var drawerState = $fvE4w.Provider.use(undefined);
    return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: match.isMobile && drawerState === /* Open */ 2,
        children: /*#__PURE__*/ $g85JO.createElement($4XxBe.make, {
            scrollableRef: scrollableContainerRef,
            children: /*#__PURE__*/ $g85JO.createElement($fCPBg.make, {
                position: match$1.embedType === /* Inline */ 1 ? /* Sticky */ 0 : /* Fixed */ 1,
                showFilters: true,
                showBackToTopButton: true,
                initiator: "plp-navbar",
                scrollableContainerRef: scrollableContainerRef
            })
        })
    });
}
$6f92be1a792eb479$var$ListPageMobileNavbar.displayName = "ListPageMobileNavbar";
var $6f92be1a792eb479$export$dd44f18ab656f3bb = $6f92be1a792eb479$var$ListPageMobileNavbar;
 /* react Not a pure module */ 
});

parcelRegister("jHdza", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $e56c8e7071d9953f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $1xf0g = parcelRequire("1xf0g");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $v7lDW = parcelRequire("v7lDW");

var $iCVlB = parcelRequire("iCVlB");

var $8E2YL = parcelRequire("8E2YL");

var $ij6do = parcelRequire("ij6do");
function $e56c8e7071d9953f$var$ListPageMobileFilters(Props) {
    var activeCategory = Props.activeCategory;
    var connection = Props.connection;
    var isOpen = Props.isOpen;
    var isBombayshirts = $iCVlB.useIsBombay(undefined);
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $hBcYV.useRouter(undefined);
    var appliedFilters = match$1.productFilters;
    var appliedSort = match$1.productSort;
    var match$2 = $8E2YL.use(undefined);
    var settings = match$2.config.settings;
    var match$3 = settings.indexNode;
    var parentCategory = activeCategory !== undefined ? activeCategory : match$3 !== undefined ? match$3 : $ij6do.empty;
    var match$4 = settings.indexNode;
    var connection$1 = connection !== undefined ? connection : match$4 !== undefined ? $1xf0g.ExternalConnection.getStoreCategoryConnection(match$4) : undefined;
    return $2whNH.mapWithDefault(connection$1, null, function(connection) {
        if (isMobile || isBombayshirts) return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($v7lDW.make, {
            connection: connection,
            panelSize: settings.panelSize,
            isOpen: isOpen,
            fullscreen: true,
            enabledSort: isMobile,
            appliedFilters: appliedFilters,
            appliedSort: appliedSort,
            zIndex: settings.zIndexInt,
            key: parentCategory.id
        }));
        else return null;
    });
}
$e56c8e7071d9953f$var$ListPageMobileFilters.displayName = "ListPageMobileFilters";
var $e56c8e7071d9953f$export$dd44f18ab656f3bb = $e56c8e7071d9953f$var$ListPageMobileFilters;
 /* react Not a pure module */ 
});

parcelRegister("3cqdW", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $2546d599e32c6ee0$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $hkOky = parcelRequire("hkOky");

var $dJhID = parcelRequire("dJhID");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $jQE31 = parcelRequire("jQE31");

var $gUsPc = parcelRequire("gUsPc");
function $2546d599e32c6ee0$export$313c36e1b57352a6(param) {
    var offsetForStickyElements = $gUsPc.useEffective(undefined);
    var match = $9pMGg.use(undefined);
    var match$1 = $jQE31.Context.use(undefined);
    var match$2 = match$1.state;
    var secondaryNavbarHeight = match$2.secondaryNavbarHeight;
    var effectiveTotalHeight = match$2.showPrimaryNavbar ? match$2.primaryNavbarHeight + secondaryNavbarHeight | 0 : secondaryNavbarHeight;
    return effectiveTotalHeight + (match.embedType === /* Inline */ 1 ? offsetForStickyElements : 0) | 0;
}
function $2546d599e32c6ee0$var$ListPageSidebarWrapper(Props) {
    var category = Props.category;
    var appliedFilters = Props.appliedFilters;
    var appliedSort = Props.appliedSort;
    var shouldShowSidebar = Props.shouldShowSidebar;
    var isSidebarOpen = Props.isSidebarOpen;
    var topLevelCategories = Props.topLevelCategories;
    var onCategoryClick = Props.onCategoryClick;
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    $9pMGg.use(undefined);
    var match$1 = $aSJcu.use(undefined);
    var offset = $2546d599e32c6ee0$export$313c36e1b57352a6(undefined);
    return /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: isSidebarOpen && shouldShowSidebar,
        children: /*#__PURE__*/ $g85JO.createElement($dJhID.make, {
            componentName: "Sidebar",
            children: /*#__PURE__*/ $g85JO.createElement($hkOky.make, {
                settings: settings,
                category: category,
                appliedFilters: appliedFilters,
                appliedSort: appliedSort,
                topLevelCategories: topLevelCategories,
                margin: offset,
                height: match$1.windowSize.height - offset | 0,
                openLinkInNewTab: settings.openLinkInNewTab,
                show: true,
                onItemClick: onCategoryClick
            })
        })
    });
}
$2546d599e32c6ee0$var$ListPageSidebarWrapper.displayName = "ListPageSidebarWrapper";
var $2546d599e32c6ee0$export$dd44f18ab656f3bb = $2546d599e32c6ee0$var$ListPageSidebarWrapper;
 /* react Not a pure module */ 
});

parcelRegister("84pt4", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $01842b28ba27ad01$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $c6E1z = parcelRequire("c6E1z");

var $3QSSt = parcelRequire("3QSSt");

var $7xAyC = parcelRequire("7xAyC");

var $gFKzh = parcelRequire("gFKzh");

var $5bEXW = parcelRequire("5bEXW");

var $aSJcu = parcelRequire("aSJcu");

var $2ZaET = parcelRequire("2ZaET");

var $9pMGg = parcelRequire("9pMGg");

var $iJp5F = parcelRequire("iJp5F");

var $8E2YL = parcelRequire("8E2YL");

var $ij6do = parcelRequire("ij6do");
function $01842b28ba27ad01$var$RelatedProductsContent(Props) {
    var productId = Props.productId;
    var categoryId = Props.categoryId;
    var hideOutOfStock = Props.hideOutOfStock;
    var viewport = Props.viewport;
    var render = Props.render;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $8E2YL.use(undefined);
    var match$2 = match$1.config;
    var account = match$2.transitiveAccount;
    var configId = match$2.id;
    var match$3 = $9pMGg.use(undefined);
    var swr = $c6E1z.useRelatedProducts(productId, match$2.transitiveStoreId, categoryId, hideOutOfStock, true, match$3.smartnavApiHost, match$3.market, undefined);
    var match$4 = $7xAyC.getPageInfo(swr, function(page) {
        return page.page.next;
    }, function(page) {
        return page.products;
    });
    var setSize = match$4.setSize;
    var size = match$4.size;
    var error = swr.error;
    var products = $2whNH.getWithDefault(match$4.contents, []);
    var previousProducts = $3QSSt.usePreviousDistinct(products);
    var products$1 = products.length === 0 ? previousProducts : products;
    $g85JO.useEffect(function() {
        if (products$1.length !== 0) {
            var newrecord = $7bjme.obj_dup($ij6do.empty);
            $gFKzh.trackRetargeting(account, configId, (newrecord.title = "Related Products", newrecord.id = "related-products", newrecord), undefined, undefined, isMobile, undefined, undefined, undefined, products$1, undefined, "view_item_list");
        }
    }, [
        $i7mYY.joinWith(products$1, "|", function(p) {
            return p.id;
        })
    ]);
    var lastPageRef = $g85JO.useRef(null);
    var match$5 = $iJp5F.use(lastPageRef, viewport, undefined, [
        0.5
    ], undefined, undefined, undefined, undefined);
    var isIntersecting = match$5.isIntersecting;
    var loadedAll = match$4.numLoadedPages >= size;
    $g85JO.useEffect(function() {
        if (isIntersecting && loadedAll) $iv6Yc._1(setSize, size + 1 | 0);
    }, [
        isIntersecting,
        loadedAll,
        setSize,
        size
    ]);
    var loading = /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: !match$4.reachedEnd && error === undefined,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(lastPageRef),
            className: $ezf3v.prefix("h-12 text-center flex items-center justify-center")
        }, "Loading more products...")
    });
    return /*#__PURE__*/ $g85JO.createElement("div", undefined, $iv6Yc._1(render, products$1), loading);
}
$01842b28ba27ad01$var$RelatedProductsContent.displayName = "RelatedProductsContent";
var $01842b28ba27ad01$export$dd44f18ab656f3bb = $01842b28ba27ad01$var$RelatedProductsContent;
 /* react Not a pure module */ 
});

parcelRegister("cMFWg", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $94ea7fde96f4417f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $1xf0g = parcelRequire("1xf0g");

var $d9SaG = parcelRequire("d9SaG");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $ij6do = parcelRequire("ij6do");
function $94ea7fde96f4417f$var$StoreCategoryProductsContent(Props) {
    var layout = Props.layout;
    var categoryId = Props.categoryId;
    var isZoomEnabled = Props.isZoomEnabled;
    var sourceNodeId = Props.sourceNodeId;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var settings = match$1.settings;
    var categories = match$1.categories;
    $9pMGg.use(undefined);
    var connection = $g85JO.useMemo(function() {
        return {
            TAG: /* StoreCategory */ 0,
            _0: {
                categoryId: categoryId,
                sortBy: /* Default */ 0,
                filterBy: undefined,
                count: 100,
                relatedMediaCount: undefined
            }
        };
    }, [
        categoryId
    ]);
    var category = $g85JO.useMemo(function() {
        var category = $2whNH.flatMap(sourceNodeId, function(sourceNodeId) {
            return $1xf0g.getCategoryById(categories, sourceNodeId);
        });
        if (category !== undefined) {
            var newrecord = $7bjme.obj_dup(category);
            var categoryType = category.categoryType;
            var tmp;
            if (typeof categoryType === "number" || categoryType.TAG !== /* Standard */ 1) tmp = category.categoryType;
            else {
                var categoryType$1 = categoryType._0;
                tmp = {
                    TAG: /* Standard */ 1,
                    _0: {
                        firstCard: categoryType$1.firstCard,
                        externalConnection: connection,
                        children: categoryType$1.children,
                        loadMoreChildren: categoryType$1.loadMoreChildren,
                        totalChildren: categoryType$1.totalChildren,
                        link: categoryType$1.link,
                        products: categoryType$1.products,
                        taggedMedia: categoryType$1.taggedMedia,
                        imageHotspots: categoryType$1.imageHotspots,
                        imageWidth: categoryType$1.imageWidth,
                        imageHeight: categoryType$1.imageHeight
                    }
                };
            }
            newrecord.categoryType = tmp;
            newrecord.card = $1xf0g.CategoryCard.setShape(category.card, settings.productCardShape);
            return newrecord;
        }
        var newrecord$1 = $7bjme.obj_dup($ij6do.empty);
        newrecord$1.categoryType = {
            TAG: /* Standard */ 1,
            _0: {
                firstCard: undefined,
                externalConnection: connection,
                children: [],
                loadMoreChildren: undefined,
                totalChildren: 0,
                link: undefined,
                products: [],
                taggedMedia: undefined,
                imageHotspots: undefined,
                imageWidth: undefined,
                imageHeight: undefined
            }
        };
        newrecord$1.card = $1xf0g.CategoryCard.setShape($ij6do.empty.card, settings.productCardShape);
        return newrecord$1;
    }, [
        connection,
        sourceNodeId
    ]);
    return /*#__PURE__*/ $g85JO.createElement($d9SaG.make, {
        category: category,
        scrollableContainerRef: scrollableContainerRef,
        layout: layout,
        isZoomEnabled: isZoomEnabled
    });
}
$94ea7fde96f4417f$var$StoreCategoryProductsContent.displayName = "StoreCategoryProductsContent";
var $94ea7fde96f4417f$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($94ea7fde96f4417f$var$StoreCategoryProductsContent);
 /* make Not a pure module */ 
});


parcelRegister("6udN8", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $4b903e245982fb6f$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $4b903e245982fb6f$export$1f96ae73734a86cc(key, ref) {
    $g85JO.useEffect(function() {
        var el = ref.current;
        if (!(el == null)) el.focus();
    }, [
        key
    ]);
}
 /* react Not a pure module */ 
});

})();
//# sourceMappingURL=ListPageContent.bs.45a71190.js.map
